require('./bootstrap');
import Cookies from 'js-cookie';
import Clipboard from 'clipboard';
import moment from 'moment';
import striptags from 'striptags';
var infiniteScroll = require('infinite-scroll');
import 'jquery-ui/ui/widgets/autocomplete.js';
window.striptags = striptags;
import Swal from 'sweetalert2/dist/sweetalert2.js';
window.Swal = Swal;
import Datetimepicker from 'jquery-datetimepicker';
import BigNumber from 'bignumber.js';

import { OpenSeaStreamClient } from '@opensea/stream-js';

const opensea_client = new OpenSeaStreamClient({
  token: '52af28b62b504f2ebc3c93dc1759c8f3'
});
window.opensea_client = opensea_client;

var Web3 = require("web3");
window.Web3 = Web3;

import WalletConnectProvider from "@walletconnect/web3-provider";
const evmChains = require("evm-chains");
window.evmChains = evmChains;

import Web3Modal from "web3modal";
const providerOptions = {
  walletconnect: {
    package: WalletConnectProvider,
    options: {
      rpc: {
        1: 'https://twilight-few-pallet.bsc.discover.quiknode.pro/ce44dabfb6debbe46c569aa85762496570129719/',
        56: "https://bsc-dataseed1.binance.org",
        18159: "https://mainnet-rpc.memescan.io",
      }
    }
  }
};

let web3Modal = new Web3Modal({
  cacheProvider: true,
  providerOptions,
  disableInjectedProvider: false
});
window.web3Modal = web3Modal;
let provider;
let selectedAccount;

var infure_url = 'https://twilight-few-pallet.bsc.discover.quiknode.pro/ce44dabfb6debbe46c569aa85762496570129719/';

import { createChart } from 'lightweight-charts';
window.lwaziChart = createChart;

var web3 = new Web3(infure_url);
window.ethereum_price = 0;
var chainId;
async function fetchAccountData() {
  provider = await web3Modal.connect();
  web3 = new Web3(provider);
  chainId = await web3.eth.getChainId();
  var accounts = await web3.eth.getAccounts();
  selectedAccount = accounts[0];
}
async function refreshAccountData() {
  await fetchAccountData(provider);
}

async function onConnect() {
  if (window.ethereum) {
    // console.log("ethereum");
  } else if (window.web3) {
    // console.log("web3");
  } else {
    // console.log("no web3");
  }
  provider = await web3Modal.connect();
  web3 = new Web3(provider);
  chainId = await web3.eth.getChainId();
  console.log(provider);
  // provider.on("accountsChanged", (accounts) => {
  //   fetchAccountData();
  // });
  // provider.on("chainChanged", (chainId) => {
  //   fetchAccountData();
  // });
  // provider.on("networkChanged", (networkId) => {
  //   fetchAccountData();
  // });
  await refreshAccountData();
}

async function onDisconnect() {
  if(provider.close) {
    await provider.close();
    await web3Modal.clearCachedProvider();
    provider = null;
  }
  selectedAccount = null;
}

$("body").on("click", ".connect-upgrade-web3-wallet", function(e){
  e.preventDefault();
  var this_btn = $(this);
  if($(this_btn).hasClass("btn-primary")) {
    $(this_btn).html('<div class="spinner-border text-white" role="status"></div>').addClass("disabled");
  } else {
    $(this_btn).html('<div class="spinner-border text-primary" role="status"></div>').addClass("disabled");
  }
  onConnect().then(function(chainId){
    try {
      loadUserRewards(selectedAccount).then(function(raw_tokens){
        console.log(raw_tokens);
        if($(this_btn).data("place") && $(this_btn).data("place") == "settings") {
          $(this_btn).removeClass("connect-upgrade-web3-wallet btn-primary").addClass("disconnect-wallet btn-light").html('Disconnect');
          $("#wallet_address").val(selectedAccount);
        } else if($(this_btn).data("place") && $(this_btn).data("place") == "portfolio") {

        } else {
          var tokens = parseFloat(raw_tokens / 1000000000 / 1000000).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          if(tokens == 0.00) {
            $("#wallet-account").html("No $SPACES tokens");
          } else {
            $("#wallet-account").html(tokens + "m $SPACES");
          }
          $.each($(".connect-upgrade-web3-wallet"), function(i, item) {
            $(this).removeClass("connect-upgrade-web3-wallet");
            var required_tokens = $(this).data("required");
            if(required_tokens <= (raw_tokens / 1000000000)) {
              $(this).replaceWith('<div class="is-activated"><i class="ri-check-line"></i></div>');
            } else {
              var missing_tokens = parseFloat((required_tokens - (raw_tokens / 1000000000)) / 1000000 * 1.1).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
              $(this).attr("href", "https://pancakeswap.finance/swap?outputCurrency=0x156df0dd6300C73ac692D805720967cf4464776e&exactAmount="+ (required_tokens - (raw_tokens / 1000000000)) * 1.1 +"&exactField=output").attr("target", "_blank").html('Buy '+ missing_tokens +'m $SPACES').addClass("buyInternal").data("required_tokens_swap", (required_tokens - (raw_tokens / 1000000000)) * 1.1);
            }
          });
        }
        raw_tokens = raw_tokens / 1000000000;
        $.ajax({
          type: "POST",
          url: "/account/update-wallet/connect",
          data: {
            wallet_tokens: raw_tokens,
            wallet_address: selectedAccount,
            _token: $('meta[name="csrf-token"]').attr("content"),
          },
          success: function(data) {
            if(data.type == "error") {

            } else {
              $(this_btn).removeClass("connect-upgrade-web3-wallet btn-primary").addClass("disconnect-wallet btn-light").html('Disconnect');
              if($(this_btn).data("place") && $(this_btn).data("place") == "settings") {
                $("#wallet_address").val(selectedAccount);
              }
              $(this_btn).removeClass("disabled");
              if($(this_btn).data("place") && $(this_btn).data("place") == "portfolio") {
                location.reload();
              }
            }
          }
        });
      });
    } catch (e) {
      $.ajax({
        type: "POST",
        url: "/account/update-wallet/connect",
        data: {
          wallet_tokens: 0,
          wallet_address: selectedAccount,
          _token: $('meta[name="csrf-token"]').attr("content"),
        },
        success: function(data) {
          if(data.type == "error") {

          } else {
            $(this_btn).removeClass("connect-upgrade-web3-wallet btn-primary").addClass("disconnect-wallet btn-light").html('Disconnect');
            if($(this_btn).data("place") && $(this_btn).data("place") == "settings") {
              $("#wallet_address").val(selectedAccount);
            }
            $(this_btn).removeClass("disabled");
            if($(this_btn).data("place") && $(this_btn).data("place") == "portfolio") {
              location.reload();
            }
          }
        }
      });
    }
  });
});
if($("#dropdownUserProfile")[0] && $("#dropdownUserProfile").data("address") && $(".connect-upgrade-web3-wallet")[0]) {
  $(".connect-upgrade-web3-wallet")[0].click();
}
$("body").on("click", ".disconnect-wallet", function(e){
  e.preventDefault();
  var this_btn = $(this);
  $.ajax({
    type: "POST",
    url: "/account/update-wallet/disconnect",
    data: {
      _token: $('meta[name="csrf-token"]').attr("content"),
    },
    success: function(data) {
      if(data.type == "error") {

      } else {
        $("#wallet_address").val('');
        $(this_btn).addClass("connect-upgrade-web3-wallet btn-primary").removeClass("disconnect-wallet btn-light").html('Connect wallet');
      }
    }
  });
});
setTimeout(function(){
  $('#preloader').fadeOut(300);
}, 300);
$('body').on("click", "a", function(){
  $('#preloader').fadeIn(300);
  setTimeout(function(){
    $('#preloader').fadeOut(300);
  }, 300);
});

var spaces_price;
setTimeout(function(){
  if($(".gas-price-gwei")[0]) {
    web3.eth.getGasPrice(function(e, r) {
      $(".gas-price-gwei").html(parseFloat(web3.utils.fromWei(r, 'gwei')).toFixed(0));
    });
  }
  if($(".ethereum-price")[0]) {
    var cg_eth_price_url = "https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd";
    var xhr = new XMLHttpRequest();
    xhr.open("GET", cg_eth_price_url);
    xhr.setRequestHeader("accept", "application/json");
    xhr.onreadystatechange = function () {
       if (xhr.readyState === 4) {
         var json = JSON.parse(xhr.responseText);
         var results = json.ethereum;
         $(".ethereum-price").html(results.usd);
         ethereum_price = results.usd;
         if($(".marketing-wallet-balance")[0]) {
           web3.eth.getBalance('0x241e58574C89bB860018dFae977672b758F746d7').then(
               function (weiBalance) {
                   let ethBalance = web3.utils.fromWei(weiBalance, 'ether');
                   $(".marketing-wallet-balance").html(parseFloat(ethBalance).toFixed(5));
               }
           );
           var xhr_m = new XMLHttpRequest();
           xhr_m.open("GET", "/get-internal-wallets?address=0x241e58574C89bB860018dFae977672b758F746d7");
           xhr_m.setRequestHeader("accept", "application/json");
           xhr_m.onreadystatechange = function () {
             if (xhr_m.readyState === 4) {
                var json = JSON.parse(xhr_m.responseText);
                var weiBalance = 0;
                $.each(json, function(i, item) {
                  if(item.from == 0x241e58574C89bB860018dFae977672b758F746d7) {
                    weiBalance = weiBalance + parseInt(item.value);
                  }
                });
                weiBalance = weiBalance.toString();
                let ethBalance = web3.utils.fromWei(weiBalance, 'ether');
                $(".marketing-wallet-balance-usd").html(parseInt(results.usd * ethBalance).toLocaleString('en-US'));
             }
          };
          xhr_m.send();
         }
         if($(".buyback-wallet-balance")[0]) {
           web3.eth.getBalance('0x84f891d5aff3e069a08eb0a66437eaf232ce9ed1').then(
               function (weiBalance) {
                   let ethBalance = web3.utils.fromWei(weiBalance, 'ether');
                   $(".buyback-wallet-balance").html(parseFloat(ethBalance).toFixed(5));
               }
           );
           var xhr_b = new XMLHttpRequest();
           xhr_b.open("GET", "/get-internal-wallets?address=0x84f891d5aff3e069a08eb0a66437eaf232ce9ed1");
           xhr_b.setRequestHeader("accept", "application/json");
           xhr_b.onreadystatechange = function () {
             if (xhr_b.readyState === 4) {
               var json = JSON.parse(xhr_b.responseText);
               var weiBalance = 0;
               $.each(json, function(i, item) {
                 if(item.from == 0x84f891d5aff3e069a08eb0a66437eaf232ce9ed1) {
                   weiBalance = weiBalance + parseInt(item.value);
                 }
               });
               weiBalance = weiBalance.toString();
               let ethBalance = web3.utils.fromWei(weiBalance, 'ether');
               $(".buyback-wallet-balance-usd").html(parseInt(results.usd * ethBalance).toLocaleString('en-US'));
             }
          };
          xhr_b.send();
         }
         if($(".marketing-wallet-balance")[0]) {
           web3.eth.getBalance('0x241e58574C89bB860018dFae977672b758F746d7').then(
               function (weiBalance) {
                   let ethBalance = web3.utils.fromWei(weiBalance, 'ether');
                   $(".marketing-wallet-balance").html(parseFloat(ethBalance).toFixed(5));
               }
           );
         }
         if($(".dead-wallet-balance")[0]) {
           var xhr_d = new XMLHttpRequest();
           xhr_d.open("GET", "/dead-wallet-balance");
           xhr_d.setRequestHeader("accept", "application/json");
           xhr_d.onreadystatechange = function () {
             if (xhr_d.readyState === 4) {
                var json = JSON.parse(xhr_d.responseText);
                $(".dead-wallet-balance").html('<i class="ri-gas-station-line"></i> <strong>'+ parseFloat(json.burned / 1000000000000 * 100).toFixed(2) + "</strong>%");
                $(".gas-station").find(".progress-bar").width(parseFloat(json.burned / 1000000000000 * 100).toFixed(2) + "%");
             }
          };
          xhr_d.send();
        }
       }};
    xhr.send();
  }
  if($(".ethereum-price")[0]) {
    function update_eth_price() {
      var cg_eth_price_url = "https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd";
      var xhr = new XMLHttpRequest();
      xhr.open("GET", cg_eth_price_url);
      xhr.setRequestHeader("accept", "application/json");
      xhr.onreadystatechange = function () {
       if (xhr.readyState === 4) {
         var json = JSON.parse(xhr.responseText);
         var results = json.ethereum;
         $(".ethereum-price").html(results.usd);
         // web3.eth.getGasPrice(function(e, r) {
         //   $(".gas-price-gwei").html(parseFloat(web3.utils.fromWei(r, 'gwei')).toFixed(0));
         // });
       }
     };
     xhr.send();
     setTimeout(function(){
       update_eth_price();
     }, 30000);
    }
    update_eth_price();
  }
  if($(".binance-price")[0]) {
    function update_binance_price() {
      var cg_eth_price_url = "https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd";
      var xhr = new XMLHttpRequest();
      xhr.open("GET", cg_eth_price_url);
      xhr.setRequestHeader("accept", "application/json");
      xhr.onreadystatechange = function () {
       if (xhr.readyState === 4) {
         var json = JSON.parse(xhr.responseText);
         var results = json.binancecoin;
         $(".binance-price").html(results.usd);
       }
     };
     xhr.send();
     setTimeout(function(){
       update_binance_price();
     }, 30000);
    }
    update_binance_price();
  }
  if($(".get-current-spaceplatform-currency")[0]) {
    function update_platform_currency_price() {
      var cg_eth_price_url = "https://api.coingecko.com/api/v3/simple/price?ids="+ $(".get-current-spaceplatform-currency").data("currency") +"&vs_currencies=usd";
      var xhr = new XMLHttpRequest();
      xhr.open("GET", cg_eth_price_url);
      xhr.setRequestHeader("accept", "application/json");
      xhr.onreadystatechange = function () {
       if (xhr.readyState === 4) {
         var json = JSON.parse(xhr.responseText);
         var results = json[Object.keys(json).at(0)];
         $(".get-current-spaceplatform-currency").html(results.usd);
       }
     };
     xhr.send();
     // setTimeout(function(){
     //   update_platform_currency_price();
     // }, 30000);
    }
    update_platform_currency_price();
  }
  if($(".spaces-price")[0]) {
    function update_binance_price() {
      var cg_eth_price_url = "https://api.coingecko.com/api/v3/simple/price?ids=astrospaces-io&vs_currencies=usd";
      var xhr = new XMLHttpRequest();
      xhr.open("GET", cg_eth_price_url);
      xhr.setRequestHeader("accept", "application/json");
      xhr.onreadystatechange = function () {
       if (xhr.readyState === 4) {
         var json = JSON.parse(xhr.responseText);
         var results = json["astrospaces-io"];
         spaces_price = results.usd;
         $(".spaces-price").html(parseFloat(results.usd * 1000000000).toFixed(2));
       }
     };
     xhr.send();
     setTimeout(function(){
       update_binance_price();
     }, 30000);
    }
    update_binance_price();
  }
}, 500);

$("body").tooltip({
  selector: '[data-toggle="tooltip"]'
});
$('[data-toggle="tooltip-window"]').tooltip({boundary: 'window'});

$("body").on("click", "tr.link", function(e){
  // if($(e.target).hasClass("btn")) return;
  // if($(e.currentTarget).hasClass("btn")) return;
  window.location.href = $(this).data("url");
});
$("body").on("click", ".home-top-coin-links", function(e){
  e.preventDefault();
  if($(this).hasClass("single-giveaway")) return;
  // if($(e.target).hasClass("btn")) return;
  // if($(e.currentTarget).hasClass("btn")) return;
  window.location.href = $(this).attr("href");
});
$("body").on("click", ".open-board-btn", function(e){
  window.location.href = $(this).data("url");
});
$("body").on("click", ".posts .single", function(e){
  if(!$("body").hasClass("chat-enabled")) {
    if($(e.target).is("a") || $(e.target).is("button") || $(e.target).hasClass(".dropdown-toggle")) return;
    if($(e.currentTarget).is("a") || $(e.currentTarget).is("button") || $(e.currentTarget).hasClass(".dropdown-toggle")) return;
    if($(e.target).is("img") || $(e.currentTarget).is("img")) return;
    if($(e.target).hasClass("open-modal-rarities") || $(e.currentTarget).hasClass("open-modal-rarities") || $(e.target.offsetParent).hasClass("open-modal-rarities")) return;
    if($(this).data("url") !== undefined && $(this).data("url").length !== 0) {
      window.location.href = $(this).data("url");
    }
  }
});

$("body").on("click", "a.influencer-link", function(e){
  if($(e.target).hasClass("btn")) return;
  if($(e.currentTarget).hasClass("btn")) return;
  window.location.href = $(this).attr("href");
});

$("body").on("click", ".sign-in-to-vote", function(e){
  e.preventDefault();
  if($("#btn-connect").is(":disabled")) {
    $(".no-connection").addClass("active").removeClass("hidden");
  } else {
    $("#btn-connect").click();
  }
});
$("body").on("click", ".vote-on-coin", function(e){
  e.preventDefault();
  var this_btn = $(this);
  var this_btn_content = $(this_btn).html();
  if($(this).hasClass("disabled")) {
    return;
  }
  $(this_btn).html('<div class="spinner-border text-white" role="status"></div>').addClass("disabled");
  if($(this_btn).data("address") == undefined) {
    $.ajax({
      type: "POST",
      url: "/coins/upvote",
      data: {
        id: $(this_btn).data("id"),
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function(data) {
        if(data.type == "error") {
          $(this_btn).html("Contact support").removeClass("btn-outline-primary").addClass("btn-danger text-center");
        } else if(data.type == "error") {
          $(".vote-on-coin").removeClass("vote-on-coin").addClass("disabled").find("span").html('<i class="ri-lock-fill"></i> Limited');
        } else {
          $(this_btn).html(this_btn_content).removeClass("vote-on-coin");
          $(this_btn).find("span").html('<i class="ri-check-line"></i>');
          $(this_btn).find("strong").html(parseInt($(this_btn).find("strong").html()) + data.weight);
        }
      }
    });
  } else {
    $.ajax({
      type: "POST",
      url: "/coins/upvote",
      data: {
        address: $(this_btn).data("address"),
        type: $(this_btn).data("type"),
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function(data) {
        if(data.type == "error") {
          $(this_btn).html("Contact support").removeClass("btn-outline-primary").addClass("btn-danger text-center");
        } else {
          $(this_btn).html(this_btn_content).removeClass("vote-on-coin");
          $(this_btn).find("span").html('<i class="ri-check-line"></i>');
          $(this_btn).find("strong").html(parseInt($(this_btn).find("strong").html()) + data.weight);
        }
      }
    });
  }
});

async function getWeb3Account() {
    const web3 = new Web3(provider);
    var accounts = await web3.eth.getAccounts();
    return accounts[0];
}
$('#copy-shill-message').popover({
  html: true
});
if($("#copy-shill-message")[0]) {
  document.getElementById("copy-shill-message").addEventListener("click", function() {
      copyToClipboard(document.getElementById("shill-message"));
  });

  function copyToClipboard(elem) {
      var targetId = "_hiddenCopyText_";
      var isInput = elem.tagName === "INPUT" || elem.tagName === "TEXTAREA";
      var origSelectionStart, origSelectionEnd;
      if (isInput) {
          target = elem;
          origSelectionStart = elem.selectionStart;
          origSelectionEnd = elem.selectionEnd;
      } else {
          target = document.getElementById(targetId);
          if (!target) {
              var target = document.createElement("textarea");
              target.style.position = "absolute";
              target.style.left = "-9999px";
              target.style.top = "0";
              target.id = targetId;
              document.body.appendChild(target);
          }
          target.textContent = elem.textContent;
      }

      var currentFocus = document.activeElement;
      target.focus();
      target.setSelectionRange(0, target.value.length);

      var succeed;
      try {
      	  succeed = document.execCommand("copy");
      } catch(e) {
          succeed = false;
      }
      if (currentFocus && typeof currentFocus.focus === "function") {
          currentFocus.focus();
      }

      if (isInput) {
          elem.setSelectionRange(origSelectionStart, origSelectionEnd);
      } else {
          target.textContent = "";
      }
      return succeed;
  }
}
$("body").on("click", "#close-no-connection-btn", function(e){
  e.preventDefault();
  $(".no-connection").addClass("hidden");
});

$("body").on("click", ".toggle-dark-mode", function(e){
  e.preventDefault();
  if($("body").hasClass("dark-mode")) {
    $("body").removeClass("dark-mode");
    Cookies.set('dark-mode', 'false', { expires: 365 });
    $(".toggle-dark-mode").html('<i class="ri-moon-line"></i>');
    $(".toggle-dark-mode-footer").html('<i class="ri-moon-line"></i> <p>Turn off light</p>');
    var theme = "Light";
  } else {
    $("body").addClass("dark-mode");
    Cookies.set('dark-mode', 'true', { expires: 365 });
    $(".toggle-dark-mode").html('<i class="ri-sun-line"></i>');
    $(".toggle-dark-mode-footer").html('<i class="ri-moon-line"></i> <p>Turn on light</p>');
    var theme = "Dark";
  }
  if(chart !== undefined) {
    chart.applyOptions(themesData[theme].chart);
	  areaSeries.applyOptions(themesData[theme].series);
  }
  localStorage.removeItem("tradingview.chartproperties.mainSeriesProperties");
  localStorage.removeItem("tradingview.symboledit.dialog_last_entry");
  localStorage.removeItem("tradingview.current_theme.name");
  localStorage.removeItem("tradingview.ChartFavoriteDrawingToolbarWidget.visible");
  localStorage.removeItem("tradingview.chartproperties");
  localStorage.removeItem("tradingview.BarsMarksContainer.visibile");
});
$("body").on("click", ".toggle-dark-mode-footer", function(e){
  e.preventDefault();
  if($("body").hasClass("dark-mode")) {
    $("body").removeClass("dark-mode");
    Cookies.set('dark-mode', 'false', { expires: 365 });
    $(".toggle-dark-mode").html('<i class="ri-moon-line"></i>');
    $(".toggle-dark-mode-footer").html('<i class="ri-moon-line"></i> <p>Turn off light</p>');
    var theme = "Light";
  } else {
    $("body").addClass("dark-mode");
    Cookies.set('dark-mode', 'true', { expires: 365 });
    $(".toggle-dark-mode").html('<i class="ri-sun-line"></i>');
    $(".toggle-dark-mode-footer").html('<i class="ri-moon-line"></i> <p>Turn on light</p>');
    var theme = "Dark";
  }
  if(chart !== undefined) {
    chart.applyOptions(themesData[theme].chart);
	  areaSeries.applyOptions(themesData[theme].series);
  }
  localStorage.removeItem("tradingview.chartproperties.mainSeriesProperties");
  localStorage.removeItem("tradingview.symboledit.dialog_last_entry");
  localStorage.removeItem("tradingview.current_theme.name");
  localStorage.removeItem("tradingview.ChartFavoriteDrawingToolbarWidget.visible");
  localStorage.removeItem("tradingview.chartproperties");
  localStorage.removeItem("tradingview.BarsMarksContainer.visibile");
});

$("body").on("click", ".single-schema-select", function(e){
  e.preventDefault();
  $(".dark-mode-introducion").addClass("hidden");
  var selected_scheme = $(this).data("type");
  if(selected_scheme == "light") {
    $("body").removeClass("dark-mode");
    Cookies.set('dark-mode', 'false', { expires: 365 });
    $(".toggle-dark-mode").html('<i class="ri-moon-line"></i>');
    var theme = "Light";
  } else if(selected_scheme == "dark") {
    $("body").addClass("dark-mode");
    Cookies.set('dark-mode', 'true', { expires: 365 });
    $(".toggle-dark-mode").html('<i class="ri-sun-line"></i>');
    var theme = "Dark";
  }
  if(chart !== undefined) {
    chart.applyOptions(themesData[theme].chart);
	  areaSeries.applyOptions(themesData[theme].series);
  }
  localStorage.removeItem("tradingview.chartproperties.mainSeriesProperties");
  localStorage.removeItem("tradingview.symboledit.dialog_last_entry");
  localStorage.removeItem("tradingview.current_theme.name");
  localStorage.removeItem("tradingview.ChartFavoriteDrawingToolbarWidget.visible");
  localStorage.removeItem("tradingview.chartproperties");
  localStorage.removeItem("tradingview.BarsMarksContainer.visibile");
});

$("body").on("click", ".hide-weekly-giveaways-announcement", function(e){
  $.ajax({
    type: "POST",
    data : {
      "cookie_name": "show_giveaway_modal",
      "_token": $('meta[name="csrf-token"]').attr("content")
    },
    cache: false,
    url: "/remove-cookie",
    success: function(response){
      if(response.type == "success") {
        location.reload();
      }
    }
  });
  $(".weekly-giveaways-announcement").fadeOut(300);
  setTimeout(function(){
    $(".weekly-giveaways-announcement").remove();
  }, 301);
});

$("body").on("click", ".btn-click-connect", function(e){
  e.preventDefault();
  if($("#btn-connect").is(":disabled")) {
    $(".no-connection").addClass("active").removeClass("hidden");
  } else {
    $("#btn-connect").click();
  }
});

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/js/sw.js');
}

$("body").on("click", ".register-modal-btn", function(e){
  e.preventDefault();
  $("#loginModal").removeClass("active");
  $("#forgotPasswordModal").removeClass("active");
  $("#registerModal").addClass("active");
});
$("body").on("click", ".forgot-modal-btn", function(e){
  e.preventDefault();
  $("#loginModal").removeClass("active");
  $("#registerModal").removeClass("active");
  $("#forgotPasswordModal").addClass("active");
});
$("body").on("click", ".sign-in-modal-btn", function(e){
  e.preventDefault();
  $("#loginModal").addClass("active");
  $("#registerModal").removeClass("active");
  $("#forgotPasswordModal").removeClass("active");
});
$("body").on("click", "#btn-connect", function(e){
  e.preventDefault();
  $("#loginModal").addClass("active");
  $("#registerModal").removeClass("active");
});
$("body").on("click", ".account-closer-bg", function(e){
  e.preventDefault();
  $("#loginModal").removeClass("active");
  $("#registerModal").removeClass("active");
  $("#forgotPasswordModal").removeClass("active");
});
$("body").on("click", "#giveaway-login", function(e){
  e.preventDefault();
  $("#loginModal").addClass("active");
  $("#registerModal").removeClass("active");
});
$("body").on("submit", "#registerAccount", function(e){
  e.preventDefault();
  if($("#registration").hasClass("hidden")) {
    return;
  }
  var formData = $(this).serialize();
  $("#register_errors").html('');
  $("#registerAccount input").removeClass("text-danger border-danger");

  var this_btn = $(this).find("button.btn");
  var this_btn_content = $(this_btn).html();
  $(this_btn).html('<div class="spinner-border text-white" role="status"></div>').addClass("disabled");

  $.ajax({
    type: "POST",
    data : formData,
    cache: false,
    url: "/register-account",
    success: function(response){
      if(response.type !== "success") {
        $(this_btn).html(this_btn_content).removeClass("disabled");
      }
      if(response.email) {
        $("#register_errors").append('<div class="alert alert-danger mb-2">Please enter a valid email</div>');
        $("#register_email").addClass("text-danger border-danger");
      }
      if(response.username) {
        $("#register_errors").append('<div class="alert alert-danger mb-2">Please enter a valid username</div>');
        $("#register_name").addClass("text-danger border-danger");
      }
      if(response.password) {
        $("#register_errors").append('<div class="alert alert-danger mb-2">Please enter a valid password</div>');
        $("#register_password").addClass("text-danger border-danger");
      }
      if(response.verification) {
        $("#register_errors").append('<div class="alert alert-danger mb-2">The verification code is invalid</div>');
        $("#register_password").addClass("text-danger border-danger");
      }
      if(response.type == "error") {
        $("#register_errors").append('<div class="alert alert-danger mb-2">An unknown error occured. Please contact support on Telegram: <a href="https://t.me/astrospacesio">Contact support</a></div>');
      } else if(response.type == "success") {
        location.reload();
        gtag('event', 'account', {
          'event_category': 'user',
          'event_label': 'register'
        });
      }
    }
  });
});
$("body").on("submit", "#loginAccount", function(e){
  e.preventDefault();
  var formData = $(this).serialize();
  $("#login_errors").html('');
  var this_btn = $(this).find("button.btn");
  var this_btn_content = $(this_btn).html();
  $(this_btn).html('<div class="spinner-border text-white" role="status"></div>').addClass("disabled");
  $.ajax({
    type: "POST",
    data : formData,
    cache: false,
    url: "/login-account",
    success: function(response){
      if(response.type == "error") {
        $(this_btn).html(this_btn_content).removeClass("disabled");
        $("#login_errors").append('<div class="alert alert-danger mb-2">Unable to sign in. Please try again or create an account.</div>');
      } else if(response.type == "banned") {
        $(this_btn).html(this_btn_content).removeClass("disabled");
        $("#login_errors").append('<div class="alert alert-danger mb-2">Account has been banned. The account you\'re trying to access has been banned for violation of our terms of use. Please reach out to our support to appeal this decision.</div>');
      } else if(response.type == "deleted") {
        $(this_btn).html(this_btn_content).removeClass("disabled");
        $("#login_errors").append('<div class="alert alert-danger mb-2">Account has been deleted. This account is deleted pending information clearance. Once cleared you\'ll be able to register again.</div>');
      } else if(response.type == "success") {
        location.reload();
        gtag('event', 'account', {
          'event_category': 'user',
          'event_label': 'login'
        });
      } else {
        $(this_btn).html(this_btn_content).removeClass("disabled");
        $.each(response, function (key, item) {
          $("#login_errors").append('<div class="alert alert-danger mb-2">'+ item +'</div>');
        });
      }
    }
  });
});
$("body").on("click", "#btn-disconnect", function(e){
  e.preventDefault();
  pusher.disconnect();
  var formData = { _token: $('meta[name="csrf-token"]').attr("content") }
  $.ajax({
    type: "POST",
    data : formData,
    cache: false,
    url: "/logout-account",
    success: function(response){
      if(response.type == "success") {
        location.reload();
      }
    }
  });
});
if($(".portfolio")[0]) {
  var wallet_address = $("#user-wallet").val();
  if($("#user-wallet")[0]) {
    $("#portfolio-coins").html('<div class="card py-5"><div class="card-body"><div class="chart has-loader"><div class="spinner-border text-primary" role="status"></div></div></div></div>');
    $("#untracked-coins").addClass("mt-4").html('<div class="card py-5"><div class="card-body"><div class="chart has-loader"><div class="spinner-border text-primary" role="status"></div></div></div></div>');
    $(".fake-loading-showcase").remove();
    $.ajax({
      type: "GET",
      url: "/get-wallet-tokens/"+ wallet_address,
      data: {
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function(data) {
        // const portfolioEthBalance = web3.utils.fromWei(balance, "ether");
        // const portfolioEthBalanceUSD = parseFloat(portfolioEthBalance * $(".ethereum-price").html()).toFixed(2);
        // $("#ethereum_value").html("$"+ portfolioEthBalanceUSD);
        $("#total_transactions").html(data.txn);
        var portfolio_token_content = '';
        $.each(data.tokens, function(i, item) {
          if(item.logo !== null) {
            var logo = '<img src="'+ item.logo +'" alt="'+ item.currency.name +'">';
          } else {
            var logo = '<img src="/images/logo/128/logo-icon-white.png" alt="'+ item.currency.name +'">';
          }
          if(item.type == "erc20") {
            var network = '<img src="/images/icons/ethereum.png" alt="ERC20">';
          } else {
            var network = '<img src="/images/icons/binance-smart-chain.png" alt="BEP20">';
          }
          var coin_balance = item.balance;
          var coin_supply = item.balance_percentage;
          var coin_value = item.wallet_value;
          if(item.last_swap == "buy") {
            var coin_last_swap = "text-success";
          } else {
            var coin_last_swap = "text-danger";
          }
          portfolio_token_content += '\
          <div class="card single-portfolio-coin" data-value="'+ coin_value.replace(",", "") +'">\
            <a class="card-body" href="'+ item.url +'">\
              <div class="info">\
                <div class="network">\
                  '+ network +'\
                </div>\
                <div class="logo">\
                  '+ logo +'\
                </div>\
                <p>\
                  <strong>'+ item.currency.name +'</strong>\
                  <small class="value-display">'+ coin_balance +' <span class="badge badge-light">'+ item.currency.symbol +'</span></small>\
                </p>\
              </div>\
              <div class="price">\
                <p>\
                  <strong class="'+ coin_last_swap +' value-display">$'+ coin_value +'</strong>\
                  <small class="value-display">'+ coin_supply +'% of supply</small>\
                </p>\
              </div>\
            </a>\
          </div>';
        });
        if(portfolio_token_content.length > 0) {
          $(".togglePortfolioValue").attr("disabled", false);
          $("#total_value").html("$"+ data.total_value);
          $("#portfolio-coins").html(portfolio_token_content);
          var sortedList = $(".single-portfolio-coin");
          sortedList.sort(function(a, b){
              return $(b).data("value")-$(a).data("value")
          });
          $("#portfolio-coins").html(sortedList);
        } else {
          $("#portfolio-coins").html('<div class="alert alert-light py-4">No <strong>tracked</strong> coins found in your wallet</div>');
        }
        var portfolio_untracked_token_content = '';
        $.each(data.untracked_tokens, function(i, item) {
          var logo = '<img src="/images/logo/128/logo-icon-dark.png" alt="'+ item.currency.name +'">';
          var coin_balance = item.balance;
          portfolio_untracked_token_content += '\
          <div class="card single-portfolio-coin">\
            <div class="card-body">\
              <div class="info">\
                <p>\
                  <strong>'+ item.currency.name +'</strong>\
                  <small>'+ coin_balance +' <span class="badge badge-light">'+ item.currency.symbol +'</span></small>\
                </p>\
              </div>\
            </div>\
          </div>';
        });
        if(portfolio_untracked_token_content.length > 0) {
          $("#untracked-coins").html(portfolio_untracked_token_content).prepend('<h5 class="subtitle">Untracked coins</h5>');
        } else {
          $("#untracked-coins").html('<div class="alert alert-light">No <strong>untracked</strong> coins found in your wallet</div>');
        }
      }
    });
  } else {

  }
}

$("body").on("click", ".close-popover", function(e){
  e.preventDefault();
  $('#copy-shill-message').popover('hide');
  $(".popover").remove();
});

if($(".coin-partner")[0]) {
  $.ajax({
    type: "GET",
    data : {},
    cache: false,
    url: "/get-advertisement-partners",
    success: function(response){
      if(response.auth !== "holder") {
        $(".coin-partner.horizontal").html(response.top).addClass("active").addClass(response.user);
        $(".coin-partner.vertical.left").html(response.left).addClass("active").addClass(response.user);
        $(".coin-partner.vertical.right").html(response.right).addClass("active").addClass(response.user);
        $(".coin-partner.portfolio").html(response.portfolio).addClass("active").addClass(response.user);
      }
    }
  });
  if($(".coin-partner.vertical")[0]) {
    var coinPartners = $('.coin-partner.vertical').offset().top;
    var subtractedBuffer = 0;
    var addedBuffer = 120;
    $(window).scroll(function() {
      if ($(window).scrollTop() + addedBuffer > coinPartners) {
        if($(window).scrollTop() + addedBuffer + $('.coin-partner.vertical').height() + 50 >= $('footer').offset().top) {
          $('.coin-partner.vertical').css('top', "auto").css('bottom', "0px");
        } else {
          $('.coin-partner.vertical').css('top', $(window).scrollTop() - subtractedBuffer).css('bottom', "auto");
        }
      } else {
        $('.coin-partner.vertical').css('top', 0).css('bottom', "auto");
      }
    });
  }
}
$("body").on("click", ".save-portfolio-wallet", function(e){
  e.preventDefault();
  var wallet_address = $("#portfolio-wallet-address").val();
  $.ajax({
    type: "POST",
    data : {
      "wallet": wallet_address,
      "_token": $('meta[name="csrf-token"]').attr("content")
    },
    cache: false,
    url: "/save-account-wallet",
    success: function(response){
      if(response.type == "success") {
        location.reload();
      }
    }
  });
});
function distanceBetweenElems(elem1, elem2) {
    var e1Rect = elem1.getBoundingClientRect();
    var e2Rect = elem2.getBoundingClientRect();
    var dx = (e1Rect.left+(e1Rect.right-e1Rect.left)/2) - (e2Rect.left+(e2Rect.right-e2Rect.left)/2);
    var dy = (e1Rect.top+(e1Rect.bottom-e1Rect.top)/2) - (e2Rect.top+(e2Rect.bottom-e2Rect.top)/2);
    var dist = Math.sqrt(dx * dx + dy * dy);
    return dist;
}
$("body").on("click", ".partner-click", function(e){
  var this_btn = $(this);
  var partner_id = $(this_btn).data("id");
  $.ajax({
    type: "POST",
    data : {
      "partner_id": partner_id,
      "url": window.location.href,
      "_token": $('meta[name="csrf-token"]').attr("content")
    },
    cache: false,
    url: "/statistic-partner-banners",
    success: function(response){

    }
  });
});

const lwazi_contract_abi = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"forMarketing","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"forProduct","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"forDividends","type":"uint256"}],"name":"CalculatedBNBForEachRecipient","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"msgSender","type":"address"}],"name":"ErrorInProcess","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":false,"internalType":"bool","name":"isExcluded","type":"bool"}],"name":"ExcludeFromFees","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":false,"internalType":"bool","name":"isExcluded","type":"bool"}],"name":"ExcludeFromMaxTxLimit","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":false,"internalType":"bool","name":"isExcluded","type":"bool"}],"name":"ExcludeFromPeriodLimit","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address[]","name":"accounts","type":"address[]"},{"indexed":false,"internalType":"bool","name":"isExcluded","type":"bool"}],"name":"ExcludeMultipleAccountsFromFees","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"ethAmountSwapped","type":"uint256"}],"name":"FinishSwapTokensForEth","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"newValue","type":"uint256"},{"indexed":true,"internalType":"uint256","name":"oldValue","type":"uint256"}],"name":"GasForProcessingUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"iterations","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"claims","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"lastProcessedIndex","type":"uint256"},{"indexed":true,"internalType":"bool","name":"automatic","type":"bool"},{"indexed":false,"internalType":"uint256","name":"gas","type":"uint256"},{"indexed":true,"internalType":"address","name":"processor","type":"address"}],"name":"ProcessedDividendTracker","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"ProductFee","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"MarketingFee","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"DividendFee","type":"uint256"}],"name":"SetBuyFees","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"OldPercent","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"NewPercent","type":"uint256"}],"name":"SetMaxTxAmount","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"OldPeriod","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"NewPeriod","type":"uint256"}],"name":"SetRestrictionPeriod","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"SellProductFee","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"SellMarketingFee","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"SellDividendFee","type":"uint256"}],"name":"SetSellFees","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"OldAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"NewAmount","type":"uint256"}],"name":"SetSwapTokensAtAmount","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"tokenAmountToBeSwapped","type":"uint256"}],"name":"StartSwapTokensForEth","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"tokensSwapped","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"string","name":"to","type":"string"}],"name":"SwapAndSendTo","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"newAddress","type":"address"},{"indexed":true,"internalType":"address","name":"oldAddress","type":"address"}],"name":"UpdateDividendTracker","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"newAddress","type":"address"},{"indexed":true,"internalType":"address","name":"oldAddress","type":"address"}],"name":"UpdatePancakeRouter","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"bool","name":"status","type":"bool"}],"name":"UpdateSwappingStatus","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"bool","name":"status","type":"bool"}],"name":"UpdateTradingStatus","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"oldMarketing","type":"address"},{"indexed":false,"internalType":"address","name":"newMarketing","type":"address"},{"indexed":false,"internalType":"address","name":"oldProduct","type":"address"},{"indexed":false,"internalType":"address","name":"newProduct","type":"address"}],"name":"UpdateWallets","type":"event"},{"inputs":[],"name":"accDividendFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"accMarketingFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"accProductFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"claim","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"dividendFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"dividendTokenBalanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"dividendTracker","outputs":[{"internalType":"contract LwaziDividendTracker","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"bool","name":"status","type":"bool"}],"name":"excludeFromAllLimits","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"excludeFromDividends","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"bool","name":"excluded","type":"bool"}],"name":"excludeFromFees","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address[]","name":"accounts","type":"address[]"},{"internalType":"bool","name":"excluded","type":"bool"}],"name":"excludeMultipleAccountsFromFees","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"gasForProcessing","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"getAccountDividendsInfo","outputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"int256","name":"","type":"int256"},{"internalType":"int256","name":"","type":"int256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"getAccountDividendsInfoAtIndex","outputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"int256","name":"","type":"int256"},{"internalType":"int256","name":"","type":"int256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getClaimWait","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getLastProcessedIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getNumberOfDividendTokenHolders","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getTotalDividendsDistributed","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isExcludedFromDividends","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isExcludedFromFees","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"marketingFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"marketingWallet","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pancakePair","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pancakeRouter","outputs":[{"internalType":"contract IPancakeRouter02","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"gas","type":"uint256"}],"name":"processDividendTracker","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"product","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"productWallet","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"sellDividendFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"sellMarketingFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"sellProductFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_ProductFee","type":"uint256"},{"internalType":"uint256","name":"_MarketingFee","type":"uint256"},{"internalType":"uint256","name":"_DividendFee","type":"uint256"}],"name":"setBuyFees","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"bool","name":"status","type":"bool"}],"name":"setCanTransferBeforeTradingIsEnabled","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_SellProductFee","type":"uint256"},{"internalType":"uint256","name":"_SellMarketingFee","type":"uint256"},{"internalType":"uint256","name":"_SellDividendFee","type":"uint256"}],"name":"setSellFees","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bool","name":"status","type":"bool"}],"name":"setSwapIsEnabled","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"setSwapTokensAtAmount","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bool","name":"status","type":"bool"}],"name":"setTradingIsEnabled","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newMarketingWallet","type":"address"},{"internalType":"address","name":"newProductWallet","type":"address"}],"name":"setWallets","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"swapTokensAtAmount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"swappingEnabled","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"tradingEnabled","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"claimWait","type":"uint256"}],"name":"updateClaimWait","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newAddress","type":"address"}],"name":"updateDividendTracker","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"newValue","type":"uint256"}],"name":"updateGasForProcessing","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"newTokenBalance","type":"uint256"}],"name":"updateMinimumTokenBalanceForDividends","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newAddress","type":"address"}],"name":"updatePancakeRouter","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_token","type":"address"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"withdrawStuckTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"withdrawableDividendOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"stateMutability":"payable","type":"receive"}];
window.lwazi_contract_abi = lwazi_contract_abi;

const lwazi_contract_address = "0x156df0dd6300C73ac692D805720967cf4464776e";
window.lwazi_contract_address = lwazi_contract_address;

async function loadUserRewards(address) {
  var user_address = address;
  if(user_address == undefined || user_address.length < 38) {
    $(".dropdown-rewards .not-connected").addClass("active");
    $(".dropdown-rewards .is-connected").removeClass("active");
    return;
  }
  var contract = await new web3.eth.Contract(lwazi_contract_abi, lwazi_contract_address);
  const dividendTokenBalanceOf = await contract.methods.dividendTokenBalanceOf(address).call(function (err, res) {
    if (err) {
      $(".total_tokens-rewards").html("Unable to fetch").removeClass("loading");
      $(".total_bnb-rewards").html("Unable to fetch").removeClass("loading");
      $(".coming_bnb-rewards").html("Unable to fetch").removeClass("loading");
    } else {
      if(res < 1) {
        $(".total_tokens-rewards").html("Buy and hold $SPACES to earn BNB rewards. <small>Automatically sent daily!</small>").removeClass("loading").addClass("no-spaces");
        $(".total_bnb-rewards").closest("li").addClass("d-none");
        $(".coming_bnb-rewards").closest("li").addClass("d-none");
      } else {
        var token_holdings = parseFloat(res / 1000000000 / 1000000).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        $(".total_tokens-rewards").html(token_holdings + "m").removeClass("loading");
      }
    }
  });
  const getAccountDividendsInfo = await contract.methods.getAccountDividendsInfo(address).call(function (err, res) {
    if (err) {
      $(".total_tokens-rewards").html("Unable to fetch").removeClass("loading");
      $(".total_bnb-rewards").html("Unable to fetch").removeClass("loading");
      $(".coming_bnb-rewards").html("Unable to fetch").removeClass("loading");
    } else {
      var total_paid = parseInt(res[4]) - parseInt(res[3]);
      total_paid = web3.utils.toBN(total_paid);
      var total_paid_bnb = parseFloat(web3.utils.fromWei(total_paid, 'ether')).toFixed(5);
      $(".total_bnb-rewards").html(total_paid_bnb).removeClass("loading");
      const coming_pays = res[3];
      var coming_pays_bnb = parseFloat(web3.utils.fromWei(coming_pays, 'ether')).toFixed(5);
      $(".coming_bnb-rewards").html(coming_pays_bnb + '<a href="#" class="collect-bnb-rewards ml-2" data-toggle="tooltip" data-title="Manually collect your BNB rewards"><i class="ri-exchange-dollar-line"></i></a>').removeClass("loading");
    }
  });
  return dividendTokenBalanceOf;
}
async function enableBrowserProvider(address) {
  provider = await web3Modal.connect();
  web3 = new Web3(provider);
  await loadUserRewards(address);
}
window.loadUserRewards = loadUserRewards;
async function collectRewards() {
  var this_btn = $(".collect-bnb-rewards");
  provider = await web3Modal.connect();
  const web3 = new Web3(provider);
  const chainId = await web3.eth.getChainId();
  const chainData = evmChains.getChain(chainId);
  if(chainData.name !== "Binance Smart Chain Mainnet") {
    console.log("Wrong network selected: "+ chainData.name);
  }
  var accounts = await web3.eth.getAccounts();
  var contractAddress = "0xdb607c61Aaa2a954Bf1f9d117953F12d6c319E15";
  var contract = await new web3.eth.Contract(lwazi_contract_abi, lwazi_contract_address);
  var getData = contract.methods.claim().send({to:contractAddress, from:accounts[0]}).on('transactionHash', function(){
    $(this_btn).html('<div class="spinner-border text-primary" role="status"></div>');
  }).on('receipt', function(receipt){
    loadUserRewards(accounts[0]);
  });
}
$("body").on("click", ".collect-bnb-rewards", function(e){
  collectRewards();
});
$("body").on("click", "nav .dropdown-menu", function(e){
  e.stopPropagation();
});
$("body").on("click", "#dropdownUserProfile", function(){
  if($("#total_bnb").html().length == 0) {
    var address = $(this).data("address");
    if(address !== undefined && address.length !== 0) {
      loadUserRewards(address);
    }
  }
});
$("body").on("click", ".open-footer-btn", function(){
  $("footer").toggleClass("active");
  if($("footer").hasClass("active")) {
    $(".open-footer-btn").html('Close footer <i class="ri-arrow-drop-up-line"></i>');
    $('html, body').animate({
        scrollTop: $("footer").offset().top
    }, 300);
  } else {
    $(".open-footer-btn").html('Open footer <i class="ri-arrow-drop-down-line"></i>');
  }
});

$("body").on("click", ".toggle-buy-coin", function(e){
  e.preventDefault();
  var this_btn = $(this);
  if(!$("#buy-coin-integration").hasClass("active")) {
    $("#buy-coin-integration").addClass("active");
    $(this_btn).html('Close buy').removeClass("btn-success").addClass("btn-light");
    if(!$("#buy-coin-integration iframe")[0]) {
      $("#buy-coin-integration").html('<iframe src="'+ $(this_btn).attr("href") +'" allowtransparency="true" scrolling="no"/></iframe>');
    }
  } else {
    $("#buy-coin-integration").removeClass("active");
    $(this_btn).html("Buy "+ $(".profile h1 small").html()).addClass("btn-success").removeClass("btn-light");
  }
});
$("body").on("click", ".toggle-symbol-swap", function(e){
  e.preventDefault();
  var this_btn = $(this);
  if(!$("#swap").hasClass("active")) {
    $(this_btn).html('<div class="spinner-border text-white" role="status"></div>').addClass("disabled");
    $.ajax({
  		type: "POST",
  		url: "/symbol/"+ $("#coin-symbol").val() +"/get-swap",
  		data: {
  			_token: $('meta[name="csrf-token"]').attr("content"),
  			address: $("#coin-address").val()
  		},
  		success: function(data) {
  			if(data.type == "error") {
  				$("#swap").html(data.swap);
  			} else {
  				$("#swap").html(data.swap);
  			}
        $("#swap").addClass("active");
        $("html, body").animate({
          scrollTop: $("body").find("#swap").offset().top - 125
        }, 300);
        $(this_btn).html('Close buy').removeClass("btn-primary disabled").addClass("btn-light");
  		}
  	});
  } else {
    $("#swap").removeClass("active");
    $(this_btn).html("Buy "+ $(".coin-symbol-page-name-price .badge").html()).addClass("btn-primary").removeClass("btn-light disabled");
  }
});

new Clipboard('.posts .single .send-btn', {
    text: function(trigger) {
      $(trigger).html('Copied').removeClass("send-btn");
      return trigger.getAttribute('data-share-url');
    }
});
new Clipboard('.copy-referral-btn', {
    text: function(trigger) {
      var thisContent = $(trigger).html();
      $(trigger).width($(trigger).width()).html('Copied').addClass("disabled");
      setTimeout(function(){
        $(trigger).width('auto').html(thisContent).removeClass("disabled");
      }, 1500);
      return trigger.getAttribute('data-share-url');
    }
});

if($("#recent-posts")[0] || $("#home-live-votes")[0]) {
  setInterval(function(){
    $.each($('.single-post-timer'), function(i, val) {
      if(timeAgo($(this).data("time")) !== "NaNy") {
        $(this).html(timeAgo($(this).data("time")));
      }
    });
  }, 1000);
}

if($("#launchpad-token-setup")[0]) {
  setInterval(function(){
    $.each($('#created_since_timer'), function(i, val) {
      if(timeAgo($(this).data("time")) !== "NaNy") {
        $(this).html(timeAgo($(this).data("time")));
      }
    });
  }, 1000);
}

(function($){
  $.fn.bindDelayed = function(event,delay,url,dataCallback,callback,dataType,action){
    var xhr, timer, ct=0;
    return this.on(event,function(){
      clearTimeout(timer);
      if (xhr) xhr.abort();
      timer = setTimeout(function(){
        var id = ++ct;
        xhr = $.ajax({
          type:action||'get',
          url:url,
          data:dataCallback && dataCallback(),
          dataType:dataType||'json',
          success:function(data){
            xhr = null;
            if (id==ct) callback.call(this,data);
          }
        });
      },delay);
    });
  };
})(jQuery);

function timeAgo(date) {
  return moment.utc(date).fromNow();
}
$("body").on("keyup keydown input blur change", "#register_email_verification", function(e){
  var this_val = $(this).val();
  $("#register_email").val(this_val);
});

$("body").on("click", "#send-verification-code-btn", function(e){
  var this_btn = $(this);
  var this_btn_content = $(this_btn).html();
  $(this_btn).html('<div class="spinner-border text-white" role="status"></div>').addClass("disabled");
  grecaptcha.ready(function() {
    grecaptcha.execute('6LdfPoIeAAAAAKkNtRk-EBPmklQvd333t4G5oaA3', {action: 'send_verification_email'}).then(function(grecaptcha_token) {
      var formData = { _token: $('meta[name="csrf-token"]').attr("content"), email: $("#register_email_verification").val(), grecaptcha_token: grecaptcha_token };
      $.ajax({
        type: "POST",
        data : formData,
        cache: false,
        url: "/send-verify-email",
        success: function(response){
          if(response.type == "success") {
            $("#start").addClass("hidden");
            $("#verification").removeClass("hidden");
          } else if(response.type == "reCAPTCHA") {
            $("#register_email_verification").removeClass("text-danger border-danger");
            $(this_btn).html(this_btn_content).removeClass("disabled");
            $("#verify_errors").append('<div class="alert alert-danger mb-2">Seems automated 🤖</div>');
          } else {
            $("#register_email_verification").addClass("text-danger border-danger");
            $(this_btn).html(this_btn_content).removeClass("disabled");
            $("#verify_errors").append('<div class="alert alert-danger mb-2">'+ response.email +'</div>');
          }
        }
      });
    });
  });
});

$("body").on("click", "#verify-verification-code-btn", function(e){
  var this_val = $(this).val();
  var hidden_val = $("#verification_code_hidden").val();
  var formData = { _token: $('meta[name="csrf-token"]').attr("content"), email: $("#register_email_verification").val(), code: $("#verification_code").val() };
  $.ajax({
    type: "POST",
    data : formData,
    cache: false,
    url: "/validate-verify-email",
    success: function(response){
      if(response.type == "success") {
        $("#verification").addClass("hidden");
        $("#registration").removeClass("hidden");
        $("#registration-footer").removeClass("hidden");
      } else {
        $("#verification_errors").html('<div class="alert alert-danger mb-2">Invalid verification code.</div>').fadeIn(300);
        setTimeout(function(){
          $("#verification_errors").fadeOut(300).html('');
        }, 2500);
      }
    }
  });
});

$("body").on("submit", "#forgotPassword", function(e){
  e.preventDefault();
  var formData = $(this).serialize();
  $("#forgot_errors").html('');
  var this_btn = $(this).find("button.btn");
  var this_btn_content = $(this_btn).html();
  $(this_btn).html('<div class="spinner-border text-white" role="status"></div>').addClass("disabled");
  $.ajax({
    type: "POST",
    data : formData,
    cache: false,
    url: "/reset-account-password",
    success: function(response){
      if(response.type == "error") {
        $(this_btn).html(this_btn_content).removeClass("disabled");
        $("#forgot_errors").append('<div class="alert alert-danger mb-2">An error occured. Please try again.</div>');
      } else if(response.type == "success") {
        $("#forgotPassword").find(".card-body").html('<p class="mb-0">If an account has been registered with the entered email you should soon receive a mail with a new password.</p>');
      }
    }
  });
});


if($(".load-trending-coins")[0]) {
  $.ajax({
    type: "POST",
    url: "/get-trending-coins",
    data: {
      _token: $('meta[name="csrf-token"]').attr("content"),
    },
    success: function(data) {
      $(".trending-coins-list").html(data).removeClass("loading");
    }
  });
}
if($(".trending-coins-promotion")[0]) {
  $.ajax({
    type: "POST",
    url: "/get-trending-coins-promoted",
    data: {
      _token: $('meta[name="csrf-token"]').attr("content"),
    },
    success: function(data) {
      if(data.type !== "ios") {
        $(".trending-coins-promotion").removeClass("loading").find(".trending-coin").html(data.promo);
        if($(".start-trending-promo-btn").length == 2) {
          $(".trending-coins-promotion .ri-advertisement-line").closest(".start-trending-promo-btn").remove();
        }
      } else {
        if(data.has_ad == false ) {
          $(".trending-coins-promotion").remove();
        } else {
          $(".trending-coins-promotion").removeClass("loading").find(".coin").html(data.promo);
          $(".start-trending-promo-btn").remove();
        }
      }
    }
  });
}

if($(".load-trending-coins-index")[0]) {
  $.each($(".load-trending-coins-index"), function(i, item) {
    var container = $(this);
    var d_area = $(container).data("area");
    var d_period = $(container).data("period");
    $.ajax({
      type: "POST",
      url: "/get-trending-coins-index",
      data: {
        _token: $('meta[name="csrf-token"]').attr("content"),
        area: d_area,
        period: d_period,
      },
      success: function(data) {
        if(d_period == "billboard-1" || d_period == "billboard-2" || d_period == "billboard-3") {
          $(container).html(data.top_4);
        } else {
          $(".load-trending-coins-index.top4").html(data.top_4);
          $(".load-trending-coins-index.top15").html(data.top_15);
        }
      }
    });
  });
}
if($(".load-trending-launchpad-index")[0]) {
  $.each($(".load-trending-launchpad-index"), function(i, item) {
    var container = $(this);
    var d_area = $(container).data("area");
    var d_period = $(container).data("period");
    $.ajax({
      type: "POST",
      url: "/get-trending-coins-index",
      data: {
        _token: $('meta[name="csrf-token"]').attr("content"),
        area: d_area,
        period: d_period,
      },
      success: function(data) {
        $(".load-trending-launchpad-index.top4").html(data.top_4);
      }
    });
  });
}
if($(".load-recent-launchpad-index")[0]) {
  $.each($(".load-recent-launchpad-index"), function(i, item) {
    var container = $(this);
    var d_area = $(container).data("area");
    var d_period = $(container).data("period");
    $.ajax({
      type: "POST",
      url: "/get-trending-coins-index",
      data: {
        _token: $('meta[name="csrf-token"]').attr("content"),
        area: d_area,
        period: d_period,
      },
      success: function(data) {
        $(".load-recent-launchpad-index.top15").html(data.top_15);
      }
    });
  });
}
if($(".load-nft-collections-home")[0]) {
  $.each($(".load-nft-collections-home"), function(i, item) {
    var container = $(this);
    $.ajax({
      type: "POST",
      url: "/get-nft-collections-home",
      data: {
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function(data) {
        $(container).html(data.data);
      }
    });
  });
}
if($(".load-nft-collections")[0]) {
  $.each($(".load-nft-collections"), function(i, item) {
    var container = $(this);
    var skip = $("#skip").val();
    var type = $("#type").val();
    $.ajax({
      type: "POST",
      url: "/get-nft-collections",
      data: {
        skip: 0,
        type: type,
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function(data) {
        if(data.data.length == 0) {
          $(".load-more-nft").addClass("d-none");
        } else {
          $(container).html(data.data);
          $("#skip").val(data.skip);
          $(".load-more-nft").removeClass("d-none");
        }
      }
    });
  });
  $("body").on("click", ".load-more-nft", function(e){
    e.preventDefault();
    var this_btn = $(this);
    if($(this_btn).hasClass("disabled")) {
      return;
    }
    var this_btn_content = $(this_btn).html();
    $(this_btn).html('<div class="spinner-border text-primary" role="status"></div>').addClass("disabled").removeClass("btn-primary");
    var skip = $("#skip").val();
    var type = $("#type").val();
    var container = $(".load-nft-collections");
    $.ajax({
      type: "POST",
      url: "/get-nft-collections",
      data: {
        skip: skip,
        type: type,
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function(data) {
        $(container).append(data.data);
        $("#skip").val(data.skip);
        $(this_btn).html(this_btn_content).removeClass("disabled").addClass("btn-primary");
      }
    });
  });
}
if($(".load-nft-collection")[0]) {
  $.each($(".load-nft-collection"), function(i, item) {
    var container = $(this);
    $.ajax({
      type: "POST",
      url: "/get-nft-collection",
      data: {
        address: $(container).data("address"),
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function(data) {
        $(container).html(data);
      }
    });
  });
}
if($(".load-nft-collection-asset")[0]) {
  $.each($(".load-nft-collection-asset"), function(i, item) {
    var container = $(this);
    $.ajax({
      type: "POST",
      url: "/get-nft-collection-asset",
      data: {
        address: $(container).data("address"),
        token: $(container).data("token"),
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function(data) {
        $(container).html(data);
      }
    });
  });
}

if($(".new-post #post-actions")[0]) {
  $.each($(".new-post #post-actions"), function(i, item) {
    var container = $(this);
    $.ajax({
      type: "POST",
      url: "/check-user-nfts",
      data: {
        address: $(container).data("address"),
        token: $(container).data("token"),
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function(data) {
        if(data.type == "success") {
          $(container).prepend('<div class="nft-attachment">'+ data.nfts +'</div>');
          $(container).find(".btns").prepend('<button type="button" class="btn btn-sm btn-secondary" id="attach-nft">NFT</button>');
        } else if(data.type == "empty") {
          $(container).prepend('<div class="nft-attachment empty">'+ data.nfts +'</div>');
          $(container).find(".btns").prepend('<button type="button" class="btn btn-sm btn-secondary" id="attach-nft">NFT</button>');
        }
        $.ajax({
          type: "POST",
          url: "/check-user-twitter-share-settings",
          data: {
            _token: $('meta[name="csrf-token"]').attr("content")
          },
          success: function(data) {
            if(data.type == "success") {
              $(container).prepend('<div class="nft-attachment">'+ data.nfts +'</div>');
              if(data.do_share == true) {
                var twitter_btn = '<button type="button" class="btn btn-sm" id="toggle-twitter-share" data-toggle="tooltip" data-title="Click to start sharing posts directly on your Twitter."><i class="ri-twitter-fill text-success"></i></button>';
              } else {
                var twitter_btn = '<button type="button" class="btn btn-sm" id="toggle-twitter-share" data-toggle="tooltip" data-title="Click to start sharing posts directly on your Twitter."><i class="ri-twitter-line"></i></button>';
              }
              $(container).find(".btns").prepend(twitter_btn);
            }
          }
        });
      }
    });
  });
}

$("body").on("click", "#toggle-twitter-share", function(e){
  e.preventDefault();
  Swal.fire({
    title: 'Share to Twitter?',
    text: 'Would you like to share your posts from AstroSpaces.io automatically on your Twitter account?',
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes please!',
    cancelButtonText: 'No thanks!',
    footer: '<a href="https://discord.gg/d3PkAbCaD6" target="_blank">Need help? Contact our support!</a>'
  }).then((result) => {
    if (result.isConfirmed) {
      $("#toggle-twitter-share").html('<i class="ri-twitter-fill text-success"></i>');
      var do_share = 1;
    } else {
      var do_share = 0;
      $("#toggle-twitter-share").html('<i class="ri-twitter-line"></i>');
    }
    $.ajax({
      type: "POST",
      url: "/update-user-twitter-share-settings",
      data: {
        do_share: do_share,
        _token: $('meta[name="csrf-token"]').attr("content")
      },
      success: function(data) {}
    });
  });
});

$("body").on("click", "#attach-nft", function(e){
  e.preventDefault();
  var this_btn = $(this);
  if($(this_btn).hasClass("active")) {
    $(this_btn).removeClass("active").html("NFT");
    $(".nft-attachment").removeClass("active");
    $(".single-nft-select").removeClass("active");
  } else {
    $(this_btn).addClass("active").html('<i class="ri-close-line"></i>');
    $(".nft-attachment").addClass("active");
  }
});

$("body").on("click", "#attach-gif", function(e){
  e.preventDefault();
  var this_btn = $(this);
  if($(this_btn).hasClass("active")) {
    $(this_btn).removeClass("active").html('<i class="ri-file-gif-line"></i>');
    $("#post-gif").removeClass("active");
  } else {
    $(this_btn).addClass("active").html('<i class="ri-close-line"></i>');
    $("#post-gif").addClass("active");
    $("#gifs-found").html('<div class="spinner-wrapper"><div class="spinner-border text-primary" role="status"></div></div>');
    $.ajax({
      type: "POST",
      url: "/account/get-trending-gifs",
      data: {
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function(data) {
        $("#gifs-found").html(data.content);
      }
    });
  }
});

$('#search-form-gifs-input').bindDelayed('keyup keydown keypress input', 500, '/account/search-gif', function(e) {
  $("#gifs-found").html('<div class="spinner-wrapper"><div class="spinner-border text-primary" role="status"></div></div>');
  return {
    _token: $('meta[name="csrf-token"]').attr("content"),
    search: $('#search-form-gifs-input').val()
  };
},function(response){
  $("#gifs-found").html(response);
},'html','post');

$("body").on("click", "#gifs-found .single", function(){
  var thisBtn = $(this);
  $("#attachment").addClass("active").html('<div class="spinner-wrapper"><div class="spinner-border" role="status"></div></div>');
  $("#post-gif").removeClass("active");
  $("#attach-gif").removeClass("active").html('<i class="ri-file-gif-line"></i>');
  $.ajax({
    url: "/account/save-gif-attachment",
    method: 'POST',
    data: {
      url: $(thisBtn).data("image"),
      url_large: $(thisBtn).data("image-large"),
      _token: $('meta[name="csrf-token"]').attr("content"),
    },
    success: function(data){
      $("#attachment_id").val(data.attachment_id);
      $("#attachment").html('<div class="post-attachment"><img src="'+ data.attachment_url +'"><div class="powered-by"><img src="/images/icons/powered-by-giphy-dark.png"></div></div>');
    }
  });
});

$("body").on("click", ".single-nft-select", function(e){
  e.preventDefault();
  var this_btn = $(this);
  $(".single-nft-select").removeClass("active");
  if($(this_btn).hasClass("active")) {
    $(this_btn).removeClass("active");
  } else {
    $(this_btn).addClass("active");
  }
});

if($(".load-nft-collection-asset-posts")[0]) {
  $.each($(".load-nft-collection-asset-posts"), function(i, item) {
    var container = $(this);
    $.ajax({
      type: "POST",
      url: "/get-nft-collection-asset-posts",
      data: {
        slug: $(container).data("slug"),
        token: $(container).data("token"),
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function(data) {
        $(container).html(data.content);
      }
    });
  });
}

$("body").on("click", ".post-the-swap label", function(e){
  e.preventDefault();
  var this_btn = $(this);
  if($(this_btn).hasClass("active")) {
    $(this_btn).removeClass("active").find(".toggler .circle").html('<i class="ri-close-line"></i>');
  } else {
    $(this_btn).addClass("active").find(".toggler .circle").html('<i class="ri-check-line"></i>');
  }
});
$("body").on("click", ".team-post-select label", function(e){
  e.preventDefault();
  var this_btn = $(this);
  if($(this_btn).hasClass("active")) {
    $(this_btn).removeClass("active").find(".toggler .circle").html('<i class="ri-close-line"></i>');
  } else {
    $(this_btn).addClass("active").find(".toggler .circle").html('<i class="ri-check-line"></i>');
  }
});

if($(".load-trending-boards-index")[0]) {
  $.each($(".load-trending-boards-index"), function(i, item) {
    var container = $(this);
    var d_area = $(container).data("area");
    var d_period = $(container).data("period");
    $.ajax({
      type: "POST",
      url: "/get-trending-boards-index",
      data: {
        _token: $('meta[name="csrf-token"]').attr("content"),
        area: d_area,
        period: d_period,
      },
      success: function(data) {
        $(".load-trending-boards-index").html(data.display);
      }
    });
  });
}

$("body").on("click", ".search-closer-bg", function(e){
  e.preventDefault();
  $("#searchModal").removeClass("active");
  $("body").removeClass("search-mode");
  $("#searchModal").removeClass("active");
  $(".toggle-search-mode").html('<i class="ri-search-line"></i>');
  $(".toggle-search-mode-footer").html('<i class="ri-search-line"></i> <p>Search</p> <span class="large-badge">⌘ + Space</span>');
  $(".large-search-display").removeClass("search-active");
});
$("body").on("click", ".toggle-search-mode", function(e){
  e.preventDefault();
  if($("body").hasClass("search-mode")) {
    $("body").removeClass("search-mode");
    $("#searchModal").removeClass("active");
    $(".toggle-search-mode").html('<i class="ri-search-line"></i>');
    $(".toggle-search-mode-footer").html('<i class="ri-search-line"></i> <p>Search</p> <span class="large-badge">⌘ + Space</span>');
    $(".large-search-display").removeClass("search-active");
  } else {
    $("body").addClass("search-mode");
    $("#searchModal").addClass("active");
    $(".toggle-search-mode").html('<i class="ri-close-line"></i>');
    $(".toggle-search-mode-footer").html('<i class="ri-close-line"></i> <p>Search</p> <span class="large-badge">⌘ + Space</span>');
    $(".large-search-display").addClass("search-active");
    $("#search-form-post-input").focus();
  }
});
$("body").on("click", ".toggle-search-mode-footer", function(e){
  e.preventDefault();
  if($("body").hasClass("search-mode")) {
    $("body").removeClass("search-mode");
    $("#searchModal").removeClass("active");
    $(".toggle-search-mode").html('<i class="ri-search-line"></i>');
    $(".toggle-search-mode-footer").html('<i class="ri-search-line"></i> <p>Search</p> <span class="large-badge">⌘ + Space</span>');
    $(".large-search-display").removeClass("search-active");
  } else {
    $("body").addClass("search-mode");
    $("#searchModal").addClass("active");
    $(".toggle-search-mode").html('<i class="ri-close-line"></i>');
    $(".toggle-search-mode-footer").html('<i class="ri-close-line"></i> <p>Search</p> <span class="large-badge">⌘ + Space</span>');
    $(".large-search-display").addClass("search-active");
    $("#search-form-post-input").focus();
  }
});
$("body").on("click", ".large-search-display", function(e){
  e.preventDefault();
  if($("body").hasClass("search-mode")) {
    $("body").removeClass("search-mode");
    $("#searchModal").removeClass("active");
    $(".toggle-search-mode").html('<i class="ri-search-line"></i>');
    $(".toggle-search-mode-footer").html('<i class="ri-search-line"></i> <p>Search</p>');
    $(".large-search-display").removeClass("search-active");
  } else {
    $("body").addClass("search-mode");
    $("#searchModal").addClass("active");
    $(".toggle-search-mode").html('<i class="ri-close-line"></i>');
    $(".toggle-search-mode-footer").html('<i class="ri-close-line"></i> <p>Search</p>');
    $(".large-search-display").addClass("search-active");
    $("#search-form-post-input").focus();
  }
});

$("body").on("click", ".toggle-search-area", function(e){
  e.preventDefault();
  var this_btn = $(this);
  var this_area = $(this_btn).data("value");
  $(".toggle-search-area").removeClass("active").find("i").removeClass("ri-checkbox-circle-line").addClass("ri-checkbox-blank-circle-line");
  $(this_btn).addClass("active").find("i").addClass("ri-checkbox-circle-line").removeClass("ri-checkbox-blank-circle-line");
  if(this_area == "coins") {
    $("#search-form-post-input").attr("placeholder", "Search for coins and tokens...");
  } else if(this_area == "users") {
    $("#search-form-post-input").attr("placeholder", "Search for users on AstroSpaces...");
  } else if(this_area == "nfts") {
    $("#search-form-post-input").attr("placeholder", "Search for NFT projects...");
  }
});
$('#search-form-post-input').bindDelayed('keyup keydown keypress input', 500, '/search-post', function(e) {
  $("#search-results").html('<div class="spinner-border text-primary" role="status"></div>');
  return {
    _token: $('meta[name="csrf-token"]').attr("content"),
    search: $('#search-form-post-input').val(),
    area: $(".toggle-search-area.active").data("value")
  };
},function(response){
  $("#search-results").html(response);
},'html','post');


if($("#flying-coin-data")) {
  $(window).scroll(function() {
    if ($(window).scrollTop() >= 250) {
      $("#flying-coin-data").addClass("fixed");
    } else {
      $("#flying-coin-data").removeClass('fixed');
    }
  });
}
$("body").on("click", ".toggle-team-message-btn", function(e){
  e.preventDefault();
  var this_btn = $(this);
  if($(this_btn).hasClass("dont")) {
    $("#recent-team-post").removeClass("dont")
    $(this_btn).removeClass("dont").html("Hide");
    var new_setting = 1;
  } else {
    $("#recent-team-post").addClass("dont");
    $(this_btn).addClass("dont").html("Show");
    var new_setting = 0;
  }
  $.ajax({
    type: "POST",
    url: "/update-user-team-posts",
    data: {
      _token: $('meta[name="csrf-token"]').attr("content"),
      new_setting: new_setting
    },
    success: function(data) {
      $(".load-trending-boards-index").html(data.display);
    }
  });
});


$("body").on("click", ".toggle-launchpad-token-details", function(e){
  e.preventDefault();
  var this_btn = $(this);
  if($("#is-launchpad").hasClass("dont")) {
    $("#is-launchpad").removeClass("dont")
    $(this_btn).html("Hide details");
    var new_setting = 1;
  } else {
    $("#is-launchpad").addClass("dont");
    $(this_btn).html("Show details");
    var new_setting = 0;
  }
  $.ajax({
    type: "POST",
    url: "/update-user-launchpad-details",
    data: {
      _token: $('meta[name="csrf-token"]').attr("content"),
      new_setting: new_setting
    },
    success: function(data) {
      $(".load-trending-boards-index").html(data.display);
    }
  });
});

$("body").on("click", ".start-trending-promo-btn", function(e){
  e.preventDefault();
  $(".trending-promotion-modal").addClass("flex");
  setTimeout(function(){
    $(".trending-promotion-modal").addClass("active");
  }, 10);
});

$("body").on("click", ".select-trending-time", function(e){
  e.preventDefault();
  var this_btn = $(this);
  $(".select-trending-time").removeClass("active");
  $("#book-trending-spot-btn").closest(".card-footer").find(".alert").remove();
  $("#book-trending-spot-btn").removeClass("disabled");
  $(this_btn).addClass("active");
  console.log(spaces_price);
  $("#ts-tokens").removeClass('text-muted').html(parseFloat($(this_btn).data("tokens-count")).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }));
  $("#ts-tokens-value").html(parseFloat(spaces_price * $(this_btn).data("tokens-count")).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }));
  $(this_btn).closest(".content").find(".disclaimer a").attr("href", "https://pancakeswap.finance/swap?outputCurrency=0x156df0dd6300c73ac692d805720967cf4464776e&exactAmount="+ $(this_btn).data("tokens-count") * 1.13 +"&exactField=output");
});

$('#search-space-trending-spot-input').bindDelayed('keyup keydown keypress input', 500, '/search-post', function(e) {
  $("#search-space-trending-spot-results").html('<div class="spinner-border text-primary" role="status"></div>');
  return {
    _token: $('meta[name="csrf-token"]').attr("content"),
    search: $('#search-space-trending-spot-input').val(),
    area: 'coins'
  };
},function(response){
  $("#search-space-trending-spot-results").html(response);
},'html','post');

$("body").on("click", "#search-space-trending-spot-results .coins a", function(e){
  e.preventDefault();
  var thisBtn = $(this);
  $(thisBtn).closest(".single").removeClass("single").addClass("selected");
  $(thisBtn).closest(".coins").find(".single").remove();
  $("#search-space-trending-spot-input").closest(".space-selector").remove();

})

$("body").on("click", ".trending-promotion-modal .bg", function(e){
  $(".trending-promotion-modal").removeClass("active");
  setTimeout(function(){
    $(".trending-promotion-modal").removeClass("flex");
  }, 300);
});

$("body").on("click", "#book-trending-spot-btn", function(e){
  e.preventDefault();
  var this_btn = $(this);
  var coin_address = $("#search-space-trending-spot-results").find(".selected").data("address");
  if($(this_btn).hasClass("disabled")) {
    // Alert loading
  } else if($("#search-space-trending-spot-results").find(".selected") == undefined || $("#search-space-trending-spot-results").find(".selected").length == 0) {
    $("#ts-tokens").html("Please select a coin!");
    return;
  } else {
    var user_tokens = $("#user-tokens").data("value");
    var tokens_amount = $(".select-trending-time.active").data("tokens-count");
    if(tokens_amount == undefined || tokens_amount < 5000000) {
      $("#ts-tokens").html("Please select a time period!");
      return;
    }
    payForTrendingSpot(tokens_amount, coin_address);
  }
});

async function payForTrendingSpot(tokens_amount, coin_address) {
  let provider;
  provider = await web3Modal.connect();
  const web3 = new Web3(provider);
  var accounts = await web3.eth.getAccounts();
  var sender = accounts[0];
  var chainId = await web3.eth.getChainId();
  if(chainId == "1") {
    var spaces_contract_address = "0x29cED58cd96f523f86f2771d79D64A8f58F55f5E";
  } else if(chainId == "56") {
    var spaces_contract_address = "0x156df0dd6300C73ac692D805720967cf4464776e";
  } else if(chainId == "18159") {
    var spaces_contract_address = "0x90242D0A1BC0aaCE16585848e3a032949539bbcc";
  } else {
    $(".wrong-network-modal").removeClass("hidden");
    return;
  }
  var contract = await new web3.eth.Contract(lwazi_contract_abi, spaces_contract_address);
  var wallet_balance = await contract.methods.balanceOf(sender).call();
  var payment_amount = parseInt(tokens_amount) +"000000000";
  if(parseInt(payment_amount) > wallet_balance) {
    var missing_tokens_amount = parseFloat((payment_amount - wallet_balance) / 1000000000);
    var missing_tokens_amount_buy_amount = parseFloat(missing_tokens_amount) * 1.09;
    var missing_tokens_amount_display = parseFloat(missing_tokens_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    $("#book-trending-spot-btn").addClass("disabled").closest(".card-footer").prepend('<div class="alert alert-warning"> <strong class="d-block mb-2">Insufficient $SPACES tokens</strong> <small class="d-block mb-3">You need <strong>'+ missing_tokens_amount_display +' $SPACES</strong> tokens.<br>+ 9% taxes</small> <a href="https://pancakeswap.finance/swap?outputCurrency=0x156df0dd6300C73ac692D805720967cf4464776e&exactAmount='+ missing_tokens_amount_buy_amount +'&exactField=output" class="badge badge-info" target="_blank">Buy $SPACES <i class="ri-external-link-line small-icon-position ml-1"></i></a> </div>');
    return;
  }
  const send_fuel_dead = await contract.methods.transfer("0x000000000000000000000000000000000000dead", ""+ payment_amount).send({from:sender}).on('transactionHash', function(res, err){
    $("#book-trending-spot-btn").addClass("active disabled").html('<div class="spinner-border text-white" role="status"></div>');
    $("#ts-tokens").closest(".price").html('<div class="alert alert-warning mb-0"><strong>Transaction in progress.</strong><br><small>Do <strong>not</strong> refresh the page.</small></div>');
  }).on('receipt', function(receipt){
    var txn = receipt.transactionHash;
    var status = receipt.status;
    if(status == true) {
      $.ajax({
        type: "POST",
        url: "/account/buy-trending-spot",
        data: {
          txn: txn,
          coin_address: coin_address,
          tokens: parseInt(tokens_amount),
          _token: $('meta[name="csrf-token"]').attr("content"),
        },
        success: function(data) {
          if(data.type == "error") {

          } else {
            location.reload();
          }
        }
      });
    }
  });
}


$(document).on("click", ".buy-platform-service-btn", function(e) {
  e.preventDefault();
  var this_btn = $(this);
  if(!$(this).hasClass("disabled")) {
    var service = $(this_btn).data("service");
    var buyAmount = $(this_btn).data("amount");
    var token_address = $(this_btn).data("token");
    buyPlatformService(service, buyAmount, token_address, this_btn);
  }
});
async function buyPlatformService(service, buyAmount, token_address, this_btn) {
  var this_btn_content = $(this_btn).html();

  provider = await web3Modal.connect();
  web3 = new Web3(provider);
  var accounts = await web3.eth.getAccounts();
  var sender = accounts[0];
  var account_balance = await web3.eth.getBalance(sender);
  var chainId = await web3.eth.getChainId();

  if(chainId == 56) {
    var spaces_purchase_contract = "0xE76Af925fdD4Fb3bf1b27f3a0fb2cfa43ccE76F4";
  } else {
    $(".wrong-network-modal").removeClass("hidden");
    return;
  }
  var contract_abi;
  await fetch("/abi/platform-purchases-abi.json").then(response => response.json()).then(function(json){
    contract_abi = json;
  });

  var token_contract = await new web3.eth.Contract(contract_abi, spaces_purchase_contract);

  const [spaces_contract_address] = await Promise.all([
    token_contract.methods.token().call()
  ]);

  if(token_address !== undefined && token_address.length == 42) {
    service = service +"-"+ token_address;
  }

  buyAmount = BigNumber(buyAmount * (10 ** 9));

  // CHECK APPROVAL
  var approval_required = true;
  var is_approved = false;

  var approve_abi;
  await fetch("/abi/standard-abi.json").then(response => response.json()).then(function(json){
    approve_abi = json;
  });
  var spaces_contract = await new web3.eth.Contract(approve_abi, spaces_contract_address);
  $(this_btn).html('<div class="spinner-border"></div> Checking allowance...');
	var check_approve = await spaces_contract.methods.allowance(sender, spaces_purchase_contract).call().then((allowance) => {
    allowance =  BigNumber(allowance);
    if(allowance.comparedTo(buyAmount) == 0 || allowance.comparedTo(buyAmount) == 1) {
      approval_required = false;
    } else {
      approval_required = true;
    }
	});

  if(approval_required == true) {
    // Approve tokens allowance
    $(this_btn).html('<div class="spinner-border"></div> Pending approval...');
		var do_approve = await spaces_contract.methods.approve(spaces_purchase_contract, '115792089237316195423570985008687907853269984665640564039457584007913129639935').send({from:sender}).on('transactionHash', function(res, err){
			$(this_btn).html('<div class="spinner-border"></div> Approving...');
		}).on('confirmation', () => {}).then((receipt) => {
      $(this_btn).html('<div class="spinner-border"></div> Approved...');
      is_approved = true;
		}).catch(function(ei){
		  console.log(ei);
      is_approved = false;
		});
  } else {
    is_approved = true;
  }

  if(is_approved) {
    $(this_btn).html('<div class="spinner-border"></div> Pending txn...');
    var newBuy = await token_contract.methods.buy(service, web3.utils.toBN(buyAmount)).send({
      from:sender
    }).on('transactionHash', function(res, err){
      $(this_btn).html('<div class="spinner-border"></div> Confirming...');
    }).on('confirmation', () => {}).then((receipt) => {

      console.log(receipt);

    }).catch(function(ei){
      console.log(ei);
      $(this_btn).removeClass("disabled");
      $(this_btn).html(this_btn_content);
    });
  }

}



if($("#load-avatar-nfs")[0]) {
  $("body").on("click", ".open-avatar-selection-modal", function(e){
    e.preventDefault();
    $("#nft-selection-modal").addClass("flex");
    setTimeout(function(){
      $("#nft-selection-modal").addClass("active");
    }, 10);
  });
  var container = $("#load-avatar-nfs");
  $.ajax({
    type: "POST",
    url: "/check-user-nfts-avatar",
    data: {
      address: $(container).data("address"),
      token: $(container).data("token"),
      _token: $('meta[name="csrf-token"]').attr("content"),
    },
    success: function(data) {
      if(data.type == "success") {
        $(container).html('<div class="nft-attachment">'+ data.nfts +'</div>');
      } else if(data.type == "empty") {
        $(container).html('<div class="nft-attachment empty">'+ data.nfts +'</div>');
      }
    }
  });
  $("body").on("click", "#load-space-astronaut", function(e){
    if(!$(this).hasClass("disabled")) {
      $(this).addClass("disabled").html('<div class="spinner-border"></div>');
      checkForSpaceAstronauts();
    }
  });
  $("body").on("click", "#load-avatar-nfs .single-nft-select", function(e){
    var thisBtn = $(this);
    $.ajax({
      type: "POST",
      url: "/account/update-avatar",
      data: {
        nft: 1,
        image: $(thisBtn).find("img").attr("src"),
        address: $(thisBtn).data("address"),
        token: $(thisBtn).data("token"),
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function(data) {
        $("#avatar-label").html('<img src="'+ data.image_url +'">');
				$(".u-avatar").attr("src", data.image_url);
      }
    });
  });
  $("body").on("click", "#nft-selection-modal .bg", function(e){
    $("#nft-selection-modal").removeClass("active");
    setTimeout(function(){
      $("#nft-selection-modal").removeClass("flex");
    }, 300);
  });
}

async function checkForSpaceAstronauts() {
  provider = await web3Modal.connect();
  web3 = new Web3(provider);
  var accounts = await web3.eth.getAccounts();
  var sender = accounts[0];
  var account_balance = await web3.eth.getBalance(sender);
  var chainId = await web3.eth.getChainId();
  console.log(chainId);
  if(chainId !== 18159) {

  } else {
    var contract_abi;
    await fetch("/abi/nft-contract-abi.json").then(response => response.json()).then(function(json){
      contract_abi = json;
    });
    var contract = await new web3.eth.Contract(contract_abi, "0x19ee5Fc5B9F8191E4965F816857494aB90C156a4");
    await contract.methods.checkAddressNfts(sender).call().then((ids) => {
      if(ids.length == 0) {
        $("#load-minted-nfts").html('<div class="empty"><p>Unable to find any NFTs in your wallet for this collection.</p></div>');
      } else {
        $("#load-minted-nfts").html('').addClass("has-assets");
        var post_data = {
          "contract_address": "0x19ee5Fc5B9F8191E4965F816857494aB90C156a4",
          "ids": ids,
          "partner": "pomploy.com",
          _token: $('meta[name="csrf-token"]').attr("content")
        }
        $.ajax({
          method: 'POST',
          url: 'https://astrospaces.io/cors/launchpad/get-mint-assets',
          data: post_data,
          cache: false,
          success: function(data){
            $("#load-space-astronaut").remove();
            $('#load-avatar-nfs').html('<div class="nft-attachment"></div>');
            if(data.assets.length > 0) {
              $.each(data.assets, function(i, asset) {
                $('#load-avatar-nfs .nft-attachment').append('<div class="single-nft-select" data-token="'+ asset.asset_id +'" data-address="0x19ee5Fc5B9F8191E4965F816857494aB90C156a4">\
                  <img src="'+ asset.image +'" alt="">\
                </div>');
              });
            } else {
              $('#load-avatar-nfs').html('<div class="empty">No SpaceAstronauts founds.</div>');
            }
          }
        });
      }
    }).catch(function(ei){
      console.log(ei);
    });
  }
}

$("body").on("mouseenter", ".nft_verified", function(e){
  e.preventDefault();
  if($(this).data("toggle") == undefined) {
    $(this).attr("data-toggle", "tooltip").attr("data-title", "Verified NFT");
    $(this).tooltip('show');
  }
})
window.loadUserLaunchpadRewards = async function (token, address) {
  var contract = await new web3.eth.Contract(lwazi_contract_abi, token);
  const dividendTokenBalanceOf = await contract.methods.dividendTokenBalanceOf(address).call(function (err, res) {
    if (err) {
      $("#launchpad_total_tokens").html("Unable to fetch");
    } else {
      var token_holdings = parseFloat(res / 1000000000000000000 / 1000000).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      $("#launchpad_total_tokens").html(token_holdings + "m");
    }
  });
  const getAccountDividendsInfo = await contract.methods.getAccountDividendsInfo(address).call(function (err, res) {
    if (err) {
      $("#launchpad_total_bnb").html("Unable to fetch");
      $("#launchpad_coming_bnb").html("Unable to fetch");
    } else {
      var total_paid = parseInt(res[4]) - parseInt(res[3]);
      total_paid = web3.utils.toBN(total_paid);
      var total_paid_bnb = parseFloat(total_paid / 1000000000 / 1000000).toFixed(5);
      $("#launchpad_total_bnb").html(total_paid_bnb + "m");
      $("#launchpad_rewards_total_value").html('$' + parseFloat(total_paid / 1000000000 * $("#launchpad_rewards_total_value").data("price")).toFixed(5))
      const coming_pays = res[3];
      var coming_pays_bnb = parseFloat(coming_pays / 1000000000 / 1000000).toFixed(5);
      $("#launchpad_coming_bnb").html(coming_pays_bnb + 'm <a href="#" class="claim-launchpad-token-rewards ml-2" data-token="'+ $("#launchpad_coming_bnb a").data("token") +'" data-address="'+ $("#launchpad_coming_bnb a").data("address") +'" data-toggle="tooltip" data-title="Collect rewards"><i class="ri-exchange-dollar-line"></i></a>');
    }
  });
  return dividendTokenBalanceOf;
};


window.loadUserPartnerRewardTokensRewards = async function (token) {
  provider = await web3Modal.connect();
  web3 = new Web3(provider);
  var accounts = await web3.eth.getAccounts();
  var sender = accounts[0];
  var account_balance = await web3.eth.getBalance(sender);
  var chainId = await web3.eth.getChainId();


  var rewards_abi;
  await fetch("/abi/partner-rewards-abi.json").then(response => response.json()).then(function(json){
    rewards_abi = json;
  });

  var contract = await new web3.eth.Contract(rewards_abi, token);
  const rewards_token_address = await contract.methods.rewardToken().call(function (err, rewardToken) {
    if (err) {
      // Unable to fetch
      console.log(err);
    } else {
      console.log(rewardToken);
    }
  });
  var rewards_token = await new web3.eth.Contract(rewards_abi, rewards_token_address);
  const [
    symbol,
    decimals,
    balance
  ] = await Promise.all([
    rewards_token.methods.symbol().call(),
    rewards_token.methods.decimals().call(),
    rewards_token.methods.balanceOf(sender).call(),
  ]);
  $(".partner-rewards-token-symbol").html(symbol);
  $("#partner_rewards_total_balance").html(parseFloat(balance / (10 ** decimals)).toLocaleString({maximumFractionDigits: 2 }));

  $.ajax({
    type: "POST",
    url: "/coins/get-single-coin-price",
    data: {
      address: rewards_token_address,
      _token: $('meta[name="csrf-token"]').attr("content"),
    },
    success: function(data) {
      if(data.type == "error") {
      } else {
        var rewardToken_price = data.price;
        const getAccountDividendsInfo = contract.methods.getAccountDividendsInfo(sender).call(function (err, res) {
          if (err) {
            // Unable to fetch
            console.log(err);
          } else {
            $("#partner_rewards_coming_rewards").html(parseFloat(res[3] / (10 ** decimals)).toLocaleString({maximumFractionDigits: 2 }) + '<a href="#" class="claim-presale-token-rewards ml-2" data-token="'+ token +'" data-partner="pomploy.com" data-toggle="tooltip" data-title="Collect rewards"><i class="ri-exchange-dollar-line default-symbol-position"></i></a>');
            $("#partner_rewards_total_received").html(parseFloat(res[4] / (10 ** decimals)).toLocaleString({maximumFractionDigits: 2 }));
            $("#partner_rewards_total_received_value").html("$"+ parseFloat(res[4] / (10 ** decimals) * rewardToken_price).toLocaleString({maximumFractionDigits: 2 }));
          }
        });
      }
    }
  });
  return;
};

async function collectLaunchpadRewards(contractAddress) {
  var this_btn = $(".claim-launchpad-token-rewards");
  provider = await web3Modal.connect();
  const web3 = new Web3(provider);
  const chainId = await web3.eth.getChainId();
  const chainData = evmChains.getChain(chainId);
  if(chainData.name !== "Binance Smart Chain Mainnet") {
    console.log("Wrong network selected: "+ chainData.name);
  }
  var accounts = await web3.eth.getAccounts();
  var contract = await new web3.eth.Contract(lwazi_contract_abi, contractAddress);
  var getData = contract.methods.claim().send({to:contractAddress, from:accounts[0]}).on('transactionHash', function(){
    $(this_btn).html('<div class="spinner-border text-primary" role="status"></div>');
  }).on('receipt', function(receipt){
    loadUserLaunchpadRewards(contractAddress, accounts[0]);
  });
}
$("body").on("click", ".claim-launchpad-token-rewards", function(e){
  e.preventDefault();
  collectLaunchpadRewards($(this).data("token"));
});

$("body").on("click", ".claim-presale-token-rewards", function(e){
  e.preventDefault();
  collectPresaleRewards($(this).data("token"), $(this).data("partner"));
});

async function collectPresaleRewards(contractAddress, partner) {
  var this_btn = $("#partner_rewards_coming_rewards");
  provider = await web3Modal.connect();
  const web3 = new Web3(provider);
  const chainId = await web3.eth.getChainId();
  if(partner == "pomploy.com") {
    if(chainId !== 18159) {
      await window.ethereum.request({
        method: 'wallet_addEthereumChain',
        params: [{
          chainId: web3.utils.toHex(18159),
          chainName: 'Proof Of Memes',
          nativeCurrency: {
            name: 'Proof Of Memes',
            symbol: 'POM',
            decimals: 18
          },
          rpcUrls: ['https://mainnet-rpc.memescan.io'],
          blockExplorerUrls: ['https://memescan.io']
        }]
      })
      .then((result) => {

      }).catch((error) => {

      });
    }
  }
  var accounts = await web3.eth.getAccounts();
  var contract = await new web3.eth.Contract(lwazi_contract_abi, contractAddress);
  var getData = contract.methods.claim().send({
    from:accounts[0]
  }).on('transactionHash', function(){
    $(this_btn).html('<div class="spinner-border text-primary" role="status"></div>');
  }).on('receipt', function(receipt){
    loadUserPartnerRewardTokensRewards(contractAddress);
  });
}

$("body").on("click", ".show-english-translation", function(e){
  e.preventDefault();
  var this_btn = $(this);
  $(this_btn).closest(".content").find(".translation").addClass("active");
  $(this_btn).closest(".content").find("p:first-child").addClass("text-muted");
  $(this_btn).remove();
});

$("body").on("click", ".single-notification-preview", function(e){
  e.preventDefault();
  if($(e.target).hasClass("is-profile-link")) {
    window.location.href = $(e.target).data("link");
  } else {
    window.location.href = $(this).find("a").attr("href");
  }
});

window.checkLockedLiquidity = async function (token) {
  var lock_abi = [{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"previousAdmin","type":"address"},{"indexed":false,"internalType":"address","name":"newAdmin","type":"address"}],"name":"AdminChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"beacon","type":"address"}],"name":"BeaconUpgraded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"id","type":"uint256"},{"indexed":false,"internalType":"address","name":"token","type":"address"},{"indexed":false,"internalType":"address","name":"owner","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"unlockDate","type":"uint256"}],"name":"LockAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"id","type":"uint256"},{"indexed":false,"internalType":"address","name":"token","type":"address"},{"indexed":false,"internalType":"address","name":"owner","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"unlockedAt","type":"uint256"}],"name":"LockRemoved","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"id","type":"uint256"},{"indexed":false,"internalType":"address","name":"token","type":"address"},{"indexed":false,"internalType":"address","name":"owner","type":"address"},{"indexed":false,"internalType":"uint256","name":"newAmount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"newUnlockDate","type":"uint256"}],"name":"LockUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"implementation","type":"address"}],"name":"Upgraded","type":"event"},{"inputs":[],"name":"allLocks","outputs":[{"components":[{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"address","name":"token","type":"address"},{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"lockDate","type":"uint256"},{"internalType":"uint256","name":"unlockDate","type":"uint256"}],"internalType":"struct SpaceLock.Lock[]","name":"","type":"tuple[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"allLpTokenLockedCount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"allNormalTokenLockedCount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"cumulativeLockInfo","outputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"address","name":"factory","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"lockId","type":"uint256"},{"internalType":"uint256","name":"newAmount","type":"uint256"},{"internalType":"uint256","name":"newUnlockDate","type":"uint256"}],"name":"editLock","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"fee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"start","type":"uint256"},{"internalType":"uint256","name":"end","type":"uint256"}],"name":"getCumulativeLpTokenLockInfo","outputs":[{"components":[{"internalType":"address","name":"token","type":"address"},{"internalType":"address","name":"factory","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"internalType":"struct SpaceLock.CumulativeLockInfo[]","name":"","type":"tuple[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"getCumulativeLpTokenLockInfoAt","outputs":[{"components":[{"internalType":"address","name":"token","type":"address"},{"internalType":"address","name":"factory","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"internalType":"struct SpaceLock.CumulativeLockInfo","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"start","type":"uint256"},{"internalType":"uint256","name":"end","type":"uint256"}],"name":"getCumulativeNormalTokenLockInfo","outputs":[{"components":[{"internalType":"address","name":"token","type":"address"},{"internalType":"address","name":"factory","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"internalType":"struct SpaceLock.CumulativeLockInfo[]","name":"","type":"tuple[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"getCumulativeNormalTokenLockInfoAt","outputs":[{"components":[{"internalType":"address","name":"token","type":"address"},{"internalType":"address","name":"factory","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"internalType":"struct SpaceLock.CumulativeLockInfo","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"getLock","outputs":[{"components":[{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"address","name":"token","type":"address"},{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"lockDate","type":"uint256"},{"internalType":"uint256","name":"unlockDate","type":"uint256"}],"internalType":"struct SpaceLock.Lock","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"start","type":"uint256"},{"internalType":"uint256","name":"end","type":"uint256"}],"name":"getLocksForToken","outputs":[{"components":[{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"address","name":"token","type":"address"},{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"lockDate","type":"uint256"},{"internalType":"uint256","name":"unlockDate","type":"uint256"}],"internalType":"struct SpaceLock.Lock[]","name":"","type":"tuple[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getTotalLockCount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_poolManager","type":"address"},{"internalType":"uint256","name":"_fee","type":"uint256"}],"name":"initialize","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"token","type":"address"},{"internalType":"bool","name":"isLpToken","type":"bool"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"unlockDate","type":"uint256"}],"name":"lock","outputs":[{"internalType":"uint256","name":"id","type":"uint256"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"lpLockCountForUser","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"lpLockForUserAtIndex","outputs":[{"components":[{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"address","name":"token","type":"address"},{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"lockDate","type":"uint256"},{"internalType":"uint256","name":"unlockDate","type":"uint256"}],"internalType":"struct SpaceLock.Lock","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"lpLocksForUser","outputs":[{"components":[{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"address","name":"token","type":"address"},{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"lockDate","type":"uint256"},{"internalType":"uint256","name":"unlockDate","type":"uint256"}],"internalType":"struct SpaceLock.Lock[]","name":"","type":"tuple[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"normalLockCountForUser","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"normalLockForUserAtIndex","outputs":[{"components":[{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"address","name":"token","type":"address"},{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"lockDate","type":"uint256"},{"internalType":"uint256","name":"unlockDate","type":"uint256"}],"internalType":"struct SpaceLock.Lock","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"normalLocksForUser","outputs":[{"components":[{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"address","name":"token","type":"address"},{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"lockDate","type":"uint256"},{"internalType":"uint256","name":"unlockDate","type":"uint256"}],"internalType":"struct SpaceLock.Lock[]","name":"","type":"tuple[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"poolManager","outputs":[{"internalType":"contract IPoolManager","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"proxiableUUID","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"newFee","type":"uint256"}],"name":"setFee","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_poolManager","type":"address"}],"name":"setPoolManager","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"}],"name":"totalLockCountForToken","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"totalLockCountForUser","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalTokenLockedCount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"lockId","type":"uint256"}],"name":"unlock","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newImplementation","type":"address"}],"name":"upgradeTo","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newImplementation","type":"address"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"upgradeToAndCall","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"withdrawFee","outputs":[],"stateMutability":"nonpayable","type":"function"}];
  var contract = await new web3.eth.Contract(lock_abi, "0x7ee058420e5937496F5a2096f04caA7721cF70cc");
  const lockInfo = await contract.methods.cumulativeLockInfo(token).call(function (err, res) {
    if (err) {
      console.log(err);
    } else {
      console.log(res);
      // #launchpad-lock-alert
    }
  });
  return;
};

window.twttr = function (d, s, id) {
  var t, js, fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return; js = d.createElement(s); js.id = id;
  js.src = "https://platform.twitter.com/widgets.js";
  fjs.parentNode.insertBefore(js, fjs);
  return window.twttr || (t = { _e: [], ready: function (f) { t._e.push(f) } });
  }(document, 'script', 'twitter-wjs');


if($("#userNotifications")[0]) {
  $.ajax({
    type: "POST",
    url: "/check-user-notifications-count",
    data: {
      _token: $('meta[name="csrf-token"]').attr("content"),
    },
    success: function(data) {
      if(data.count >= 1) {
        $("#userNotifications").html('<span class="badge badge-pill ml-1 badge-info notifications-pulse">'+ data.count +'</span>');
        $.each($('.website-fav-icons'), function(i, val) {
          var thisAttr = $(this).attr("href");
          thisAttr = thisAttr.replace("/fav/", "/fav-notifications/");
          $(this).attr("href", thisAttr);
        });
      } else {
        $.each($('.website-fav-icons'), function(i, val) {
          var thisAttr = $(this).attr("href");
          thisAttr = thisAttr.replace("/fav-notifications/", "/fav/");
          $(this).attr("href", thisAttr);
        });
      }
    }
  });
}

window.infiniteScroll = infiniteScroll;


$("body").on("click", ".report-post-btn", function(e){
  e.preventDefault();
  var this_btn = $(this);
  if(!$(this_btn).hasClass("disabled")) {
    $.ajax({
      type: "POST",
      url: "/account/post/report",
      data: {
        post_id: $(this_btn).data("id"),
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function(data) {
        if(data.type == "error") {
          console.log("error");
        } else {
          gtag('event', 'account', {
            'event_category': 'post',
            'event_label': 'report'
          });
          $(this_btn).addClass("disabled").html("Reported").closest(".single").addClass("is-muted");
          Swal.fire({
            title: 'Thank you!',
            text: 'We\'ve received your report and will be reviewing it as soon as possible.',
            icon: 'info',
            confirmButtonText: 'Okay!',
            footer: '<a href="https://discord.gg/d3PkAbCaD6" target="_blank">Need help? Contact our support!</a>'
          });
        }
      }
    });
  }
});

$("body").on("click", ".block-post-btn", function(e){
  e.preventDefault();
  var this_btn = $(this);
  if(!$(this_btn).hasClass("disabled")) {
    $.ajax({
      type: "POST",
      url: "/account/post/block",
      data: {
        post_id: $(this_btn).data("id"),
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function(data) {
        if(data.type == "error") {
          console.log("error");
        } else {
          gtag('event', 'account', {
            'event_category': 'post',
            'event_label': 'block'
          });
          Swal.fire({
            title: 'Post blocked!',
            text: 'The post is now blocked and you\'ll not be seing this content anymore..',
            icon: 'success',
            confirmButtonText: 'Okay!',
            footer: '<a href="https://discord.gg/d3PkAbCaD6" target="_blank">Need help? Contact our support!</a>'
          }).then((result) => {
            location.reload();
          });
        }
      }
    });
  }
});

$("body").on("click", ".follow-post-user-btn", function(e){
	e.preventDefault();
  e.stopPropagation();
	var this_btn = $(this);
  var this_btn_content = $(this_btn).html();
	$(this_btn).html('<div class="spinner-border" role="status"></div>').addClass("disabled");
	$.ajax({
		type: "POST",
		url: "/account/user/follow",
		data: {
			user_id: $(this_btn).data("user-id"),
			_token: $('meta[name="csrf-token"]').attr("content"),
		},
		success: function(data) {
			$(this_btn).removeClass("disabled").html(this_btn_content);
			if(data.type == "error") {
				console.log("error");
			} else {
				if(data.action == "follow") {
					gtag('event', 'account', {
						'event_category': 'user',
						'event_label': 'follow'
					});
					$(this_btn).find('span').html('Unfollow');
          $(this_btn).find('i').removeClass('ri-user-follow-line').addClass("ri-user-unfollow-line");
				} else {
					$(this_btn).find('span').html('Follow');
          $(this_btn).find('i').removeClass('ri-user-unfollow-line').addClass("ri-user-follow-line");
				}
			}
		}
	});
});

$("body").on("click", ".report-user-btn", function(e){
  e.preventDefault();
  var this_btn = $(this);
  if(!$(this_btn).hasClass("disabled")) {
    $.ajax({
      type: "POST",
      url: "/account/user/report",
      data: {
        id: $(this_btn).data("id"),
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function(data) {
        if(data.type == "error") {
          console.log("error");
        } else {
          gtag('event', 'account', {
            'event_category': 'user',
            'event_label': 'report'
          });
          $(this_btn).addClass("disabled").html("Reported").closest(".single").addClass("is-muted");
          Swal.fire({
            title: 'Thank you!',
            text: 'We\'ve received your report and will be reviewing it as soon as possible.',
            icon: 'info',
            confirmButtonText: 'Okay!',
            footer: '<a href="https://discord.gg/d3PkAbCaD6" target="_blank">Need help? Contact our support!</a>'
          });
        }
      }
    });
  }
});

$("body").on("click", ".block-user-btn", function(e){
  e.preventDefault();
  var this_btn = $(this);
  if(!$(this_btn).hasClass("disabled")) {
    $.ajax({
      type: "POST",
      url: "/account/user/block",
      data: {
        user_id: $(this_btn).data("id"),
        status: "block",
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function(data) {
        if(data.type == "error") {
          console.log("error");
        } else {
          gtag('event', 'account', {
            'event_category': 'user',
            'event_label': 'block'
          });
          Swal.fire({
            title: 'User blocked!',
            text: 'You\'ve blocked the users and will no longer see any posts or comments from the user.',
            icon: 'success',
            showCancelButton: true,
            confirmButtonText: 'Thanks!',
            cancelButtonText: 'Mistake. Unblock!',
            footer: '<a href="https://discord.gg/d3PkAbCaD6" target="_blank">Need help? Contact our support!</a>'
          }).then((result) => {
            if (result.isConfirmed) {
              location.reload();
            } else {
              $.ajax({
                type: "POST",
                url: "/account/user/block",
                data: {
                  user_id: $(this_btn).data("id"),
                  status: "unblock",
                  _token: $('meta[name="csrf-token"]').attr("content"),
                },
                success: function(data) {
                  if(data.type == "error") {
                    console.log("error");
                  } else {
                    gtag('event', 'account', {
                      'event_category': 'user',
                      'event_label': 'unblock'
                    });
                    Swal.fire({
                      title: 'User unblocked!',
                      text: 'You\'ve unblocked the user and will now see posts or comments from the user.',
                      icon: 'success',
                      confirmButtonText: 'Close message!',
                      footer: '<a href="https://discord.gg/d3PkAbCaD6" target="_blank">Need help? Contact our support!</a>'
                    }).then((result) => {
                      if (result.isConfirmed) {
                        location.reload();
                      }
                    });
                  }
                }
              });
            }
          });
        }
      }
    });
  }
});

$("body").on("click", ".unblock-user-btn", function(e){
  e.preventDefault();
  var this_btn = $(this);
  if(!$(this_btn).hasClass("disabled")) {
    $.ajax({
      type: "POST",
      url: "/account/user/block",
      data: {
        user_id: $(this_btn).data("id"),
        status: "unblock",
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function(data) {
        if(data.type == "error") {
          console.log("error");
        } else {
          gtag('event', 'account', {
            'event_category': 'user',
            'event_label': 'unblock'
          });
          Swal.fire({
            title: 'User unblocked!',
            text: 'You\'ve unblocked the user and will now see posts or comments from the user.',
            icon: 'success',
            confirmButtonText: 'Close message!',
            footer: '<a href="https://discord.gg/d3PkAbCaD6" target="_blank">Need help? Contact our support!</a>'
          }).then((result) => {
            if (result.isConfirmed) {
              location.reload();
            }
          });
        }
      }
    });
  }
});

$("body").on("click", ".mute-post-user-btn", function(e){
  e.preventDefault();
  var this_btn = $(this);
  if(!$(this_btn).hasClass("disabled")) {
    $.ajax({
      type: "POST",
      url: "/account/post/mute",
      data: {
        user_id: $(this_btn).data("id"),
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function(data) {
        if(data.type == "error") {
          console.log("error");
        } else {
          gtag('event', 'account', {
            'event_category': 'post',
            'event_label': 'mute'
          });
          $(this_btn).addClass("disabled").html("User muted");
        }
      }
    });
  }
});

$("body").on("click", ".delete-post-user-btn", function(e){
  e.preventDefault();
  var this_btn = $(this);
  if(!$(this_btn).hasClass("disabled")) {
    $.ajax({
      type: "POST",
      url: "/admin/post/delete",
      data: {
        post_id: $(this_btn).data("id"),
        _token: $('meta[name="csrf-token"]').attr("content"),
      },
      success: function(data) {
        if(data.type == "error") {
          console.log("error");
        } else {
          gtag('event', 'account', {
            'event_category': 'post',
            'event_label': 'delete'
          });
          $(this_btn).addClass("disabled").html("Reported").closest(".single").addClass("is-muted");
        }
      }
    });
  }
});

$("body").on("click", ".open-modal-rarities", function(e){
  if($(e.target).hasClass("owner")) return;
  if($(e.target).hasClass("btn")) return;
  e.preventDefault();
  var token_id = $(this).find(".asset").data("id");
  var slug = $(this).find(".asset").data("slug");
  openModalRarity(token_id, slug);
});

var openModalRarity = function(id, slug) {
  // RESET PREVIOUS DISPLAY
  setTimeout(function(){
    $(".asset-rarity-modal").addClass("active");
    setTimeout(function(){
      $(".asset-rarity-modal .bg").addClass("active");
      $("#asset-modal-content").addClass("active");
    }, 1);
  }, 10);
  $.ajax({
    type: "POST",
    url: "/nft/get/rarity-modal",
    data: {
      collection_slug: slug,
      token_id: id,
      _token: $('meta[name="csrf-token"]').attr("content"),
    },
    success: function(data) {
      if(data.type == "error") {
        $(".asset-rarity-modal").removeClass("active");
        $(".asset-rarity-modal .bg").removeClass("active");
      } else {
        $("#asset-collection").html('<a href="'+ data.asset.collection.url +'"><img src="'+ data.asset.collection.logo +'" class="mr-1"> '+ data.asset.collection.name +'</a>');
        $("#asset-preview").html('<img src="'+ data.asset.image_url +'">');
        $("#asset-rank").html("Rank "+ data.asset.rank);
        $("#asset-rarity-score").html(data.asset.rarity_score + " ARS");
        $("#asset-id").html("#"+id);

        if(data.asset.owner.address == null) {
          $("#asset-owner").attr("href", "#").addClass("disabled").html('<p class="name">Owner not found.</p>');
        } else if(data.asset.owner.address == "0x0000000000000000000000000000000000000000") {
          $("#asset-owner").attr("href", "https://opensea.io/assets/"+ data.asset.contract +"/"+ id).html('<p class="name">View owner</p>');
        } else {
          $("#asset-owner").attr("href", "https://opensea.io/"+ data.asset.owner.address).html('<div class="avatar"><img src="'+ data.asset.owner.profile_img +'" alt="'+ data.asset.owner.name +'"></div><p class="name">'+ data.asset.owner.name +'</p>');
        }
        if(data.asset.price !== null) {
          $("#asset-buy-link").attr("href", data.asset.opensea_link).removeClass("disabled").html('<strong>Buy '+ data.asset.price +' ETH</strong>');
        } else {
          $("#asset-buy-link").addClass("disabled").attr("href", "#").html("Not for sale");
        }
        if(data.asset.network == "ethereum") {
          $("#asset-opensea-link").attr("href", "https://opensea.io/assets/"+ data.asset.contract +"/"+ id).removeClass("disabled");
          $("#asset-gemxyz-link").attr("href", "https://www.gem.xyz/asset/"+ data.asset.contract +"/"+ id).removeClass("disabled");
          $("#asset-looksrare-link").attr("href", "https://looksrare.org/collections/"+ data.asset.contract +"/"+ id).removeClass("disabled");
          $("#asset-x2y2-link").attr("href", "https://x2y2.io/eth/"+ data.asset.contract +"/"+ id).removeClass("disabled");
        } else if(data.asset.network == "pomchain") {
          console.log(1);
          $("#asset-opensea-link").remove();
          $("#asset-gemxyz-link").remove();
          $("#asset-looksrare-link").remove();
          $("#asset-x2y2-link").remove();
          $("#asset-buy-link").attr("href", 'https://pomploy.com/deploy/swap?contract='+ data.asset.contract +'&recieve_id='+ id +'').removeClass("disabled").html('<img src="/images/icons/pomploy-icon.png" class="icon" alt="Pomploy"> <small class="text-white ml-2">Request swap</small>');
        } else {
          console.log(2);
          $("#asset-opensea-link").remove();
          $("#asset-gemxyz-link").remove();
          $("#asset-looksrare-link").remove();
          $("#asset-x2y2-link").remove();
          $("#asset-buy-link").html('Coming soon.');
        }
        $("#traits-loader").html('');
        if(data.asset.traits.length == 0) {
          $(".no-rankings-yet").addClass("active");
          $("#no-ars-slug").html(data.asset.collection_name);
          $("#asset-modal-content").removeClass("active");
        } else {
          $.each(data.asset.traits, function(i, item) {
            $("#asset-traits").append('<tr>\
            <td>'+ item.trait_type +'</td>\
            <td>'+ item.value +'</td>\
            <td><strong>'+ item.trait_score +'</strong> ARS</td>\
            <td>'+ item.trait_count +' ('+ item.trait_percentage +'%)</td>\
            </tr>');
          });
        }
      }
    }
  });
}
window.openModalRarity = openModalRarity;

$("body").on("click", ".asset-rarity-modal .bg", function(e){
  resetRarityModal();
});
$("body").on("click", "#close-rarity-modal-mobile", function(e){
  resetRarityModal();
});

function resetRarityModal() {
  $(".asset-rarity-modal .bg").removeClass("active");
  $("#asset-modal-content").removeClass("active");
  $(".no-rankings-yet").removeClass("active");
  setTimeout(function(){
    $(".asset-rarity-modal").removeClass("active");
    $("#asset-preview").html('<div class="loader"><div class="spinner-border" role="status"></div></div>');
    $("#traits-loader").html('<div class="loader"><div class="spinner-border" role="status"></div></div>');
    $("#asset-opensea-link").addClass("disabled").attr("href", "#");
    $("#asset-gemxyz-link").addClass("disabled").attr("href", "#");
    $("#asset-looksrare-link").addClass("disabled").attr("href", "#");
    $("#asset-x2y2-link").addClass("disabled").attr("href", "#");
    $("#asset-buy-link").addClass("disabled").attr("href", "#").html('<span class="loading-title"></span>');
    $("#asset-rank").html('<span class="loading-title"></span>');
    $("#asset-rarity-score").html('<span class="loading-title"></span>');
    $("#asset-id").html('<span class="loading-title"></span>');
    $("#asset-owner").html('<span class="loading-title"></span>');
    $("#asset-traits").html('');
  }, 300);
}

var current_url = window.location.href;
var check_unknown_error_url = (current_url.split(window.location.host)[1]).split("?")[1];
if(check_unknown_error_url !== undefined && check_unknown_error_url.length > 0) {
  if(check_unknown_error_url == "error=email-registered" || check_unknown_error_url == "success=signup" || check_unknown_error_url == "error=twitter-credentials") {
    var temp_currURL = window.location.href;
    var temp_url = (temp_currURL.split(window.location.host)[1]).split("?")[0];
    window.history.pushState({}, document.title, temp_url);
    gtag('set', 'page_path', temp_url);
    gtag('event', 'page_view');
    if(check_unknown_error_url == "error=email-registered") {
      Swal.fire({
        title: 'You\'re already registered!',
        text: 'The email connected to your Twitter is already registered on AstroSpaces.io. Please try to sign in or contact support.',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Contact support!',
        cancelButtonText: 'I\'ll try login!',
        footer: '<a href="https://discord.gg/d3PkAbCaD6" target="_blank">Need help? Contact our support!</a>'
      }).then((result) => {
        if (result.isConfirmed) {
          window.open('https://discord.gg/d3PkAbCaD6', '_blank'); // REDIRECTS TO PLATFORM BUG DISCORD
        }
      });
    } else if(check_unknown_error_url == "success=signup") {
      Swal.fire({
        title: 'Welcome astronaut!',
        text: 'We\'re happy to welcome you to AstroSpaces.io! Have a look around and join your favorite spaces!',
        icon: 'success',
        showCancelButton: false,
        confirmButtonText: 'Thank you!',
        footer: 'Now support your favorite token or NFT project!'
      });
    } else if(check_unknown_error_url == "error=twitter-credentials") {
      Swal.fire({
        title: 'Do you have a problem?',
        text: 'It\'s seems like an error occured during sign up. Please reach out to our Discord support if this problem happens again.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Contact support!',
        cancelButtonText: 'No it\'s okay!',
        footer: '<a href="https://discord.gg/d3PkAbCaD6" target="_blank">Need help? Contact our support!</a>'
      }).then((result) => {
        if (result.isConfirmed) {
          window.open('https://discord.gg/d3PkAbCaD6', '_blank'); // REDIRECTS TO PLATFORM BUG DISCORD
        }
      });
    }
  }
}

$("body").on("click", ".list-coin-overview-display", function(e){
  if($(e.target).hasClass("btn")) return;
  if($(e.currentTarget).hasClass("btn")) return;
  window.location.href = $(this).data("url");
});

$("body").on("click", ".close-all-post-actions", function(e){
  $("#post-actions").removeClass("active");
  $(".team-post-select").removeClass("active");
  $(".activate-toggler").removeClass("active");
});


$(document).keydown(function (event) {
  if($(document.activeElement).attr('id') === "post-content") {
    if((event.metaKey || event.ctrlKey) && event.which == 13) {
      $("#submit-post-content").click();
      console.log("click");
    }
  }
  if((event.metaKey || event.ctrlKey) && event.which == 32) {
    $(".toggle-search-mode")[0].click();
  }
  if((event.metaKey || event.ctrlKey) && event.which == 72) {
      $("#homelink")[0].click();
  }
  if((event.metaKey || event.ctrlKey) && event.which == 84) {
      $("#trendinglink")[0].click();
  }
  if((event.metaKey || event.ctrlKey) && event.which == 80) {
      $("#portfoliolink")[0].click();
  }
  if((event.metaKey || event.ctrlKey) && event.which == 85) {
      $("#universelink")[0].click();
  }
  if((event.ctrlKey) && event.which == 78) {
      $("#notificationslink")[0].click();
  }
  if((event.ctrlKey) && event.which == 49) {
      $("#likedProject-1")[0].click();
  }
  if((event.ctrlKey) && event.which == 50) {
      $("#likedProject-2")[0].click();
  }
  if((event.ctrlKey) && event.which == 51) {
      $("#likedProject-3")[0].click();
  }
  if((event.ctrlKey) && event.which == 52) {
      $("#likedProject-4")[0].click();
  }
  if((event.ctrlKey) && event.which == 53) {
      $("#likedProject-5")[0].click();
  }
  if((event.ctrlKey) && event.which == 54) {
      $("#likedProject-6")[0].click();
  }
  if((event.ctrlKey) && event.which == 55) {
      $("#likedProject-7")[0].click();
  }
  if((event.ctrlKey) && event.which == 56) {
      $("#likedProject-8")[0].click();
  }
  if((event.ctrlKey) && event.which == 57) {
      $("#likedProject-9")[0].click();
  }
  if((event.ctrlKey) && event.which == 48) {
      $("#likedProject-0")[0].click();
  }
  if((event.metaKey || event.ctrlKey)) {
    console.log(event.which);
  }
});

function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    console.log(userAgent);
    if (/windows phone/i.test(userAgent)) {
        return "windows";
    }
    if (/android/i.test(userAgent)) {
        return "android";
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "ios";
    }
    return "unknown";
}
if(!$("body").hasClass(".is-pwa")) {
  var mobile_device = getMobileOperatingSystem();
  if(mobile_device == "android") {
    // $("header.nav-header").addClass("has-announcement");
    // $("header.nav-header .navbar").addClass("has-announcement");
    // $("#google-play-download").addClass("active");
  } else if(mobile_device == "ios") {
    // $("header.nav-header").addClass("has-announcement");
    // $("header.nav-header .navbar").addClass("has-announcement");
    // $("#apple-app-store-download").addClass("active");
  }
}
$("body").on("click", "#delete-account", function(e){
  e.preventDefault();
  Swal.fire({
    title: 'Are you sure?',
    text: 'Are you sure you want to delete your account? This is a permanent action and will not be able to be undone.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes delete!',
    confirmButtonColor: '#dc3545',
    cancelButtonText: 'No stop!',
    footer: '<a href="https://discord.gg/d3PkAbCaD6" target="_blank">Need help? Contact our support!</a>'
  }).then((result) => {
    if (result.isConfirmed) {
      $.ajax({
  			type: "POST",
  			url: "/account/settings/delete",
  			data: {
          _token: $('meta[name="csrf-token"]').attr("content"),
        },
  			success: function(data) {
  				window.location.href = "https://astrospaces.io";
  			}
  		});
    }
  });
});


$('#pick-winner-search-coin-input').bindDelayed('keyup keydown keypress', 500, '/launchpad/tools/rbp/search-coins', function(e) {
  $("#pick-winner-search-coin-results .results").addClass("active").html('<div class="loader"><div class="spinner-border text-primary" role="status"></div></div>');
  return {
    _token: $('meta[name="csrf-token"]').attr("content"),
    search: $('#pick-winner-search-coin-input').val()
  };
},function(response){
  $("#pick-winner-search-coin-results .results").html(response);
},'html','post');


$(".datetimepicker").datetimepicker({
  scrollMonth: false
});


if($("#load-user-recent-votes-nav")[0]) {
  $.ajax({
    type: "POST",
    url: "/account/navigation/get-recent-votes",
    data: {
      url: window.location.href,
      _token: $('meta[name="csrf-token"]').attr("content"),
    },
    success: function(data) {
      if(data.type == "error") {
        console.log("error");
      } else {
        if(data.likes.length == 0) {
          $("#load-user-recent-votes-nav").remove();
        } else {
          $("#load-user-recent-votes-nav").html(data.likes);
        }
      }
    }
  });
}


if($("#payment-gateway-trending-booking")[0]) {
  checkForApproval("trending-booking");
}

if($("#payment-gateway-double-voting")[0]) {
  checkForApproval("double-voting");
}

$(document).on("click", "#pay-double-voting-btn", function(){
  var this_btn = $(this);
  var this_btn_content = $(this_btn).html();
  if(!$(this_btn).hasClass("disabled")) {
    buyDoubleVoting($(this_btn));
  }
});

async function buyDoubleVoting(this_btn){
  var this_btn_content = $(this_btn).html();
  $("#txn-status").html('');
  $(this_btn).addClass("disabled");

  provider = await web3Modal.connect();
  web3 = new Web3(provider);
  var accounts = await web3.eth.getAccounts();
  var sender = accounts[0];
  var account_balance = await web3.eth.getBalance(sender);
  var chainId = await web3.eth.getChainId();

  if(chainId == "1") {
    var spaces_contract_address = "0x29cED58cd96f523f86f2771d79D64A8f58F55f5E";
    var spaces_purchase_contract = "0xc32a28193D25d45040233C05C9C8db49b4c46A79";
  } else if(chainId == "56") {
    var spaces_contract_address = "0x156df0dd6300C73ac692D805720967cf4464776e";
    var spaces_purchase_contract = "0x069B7e05e3aB68dc7410b93A314662D22049B1e1";
  } else if(chainId == "18159") {
    var spaces_contract_address = "0x90242D0A1BC0aaCE16585848e3a032949539bbcc";
    var spaces_purchase_contract = "";
  } else if (chainId == "42161") {
    var spaces_contract_address = "0x1D05Ec50dfE0A44a396B5c68B7c482E90563252D";
    var spaces_purchase_contract = "0x93761Ff413fd905a73c5d3b9A8f6BC97df6E01A9";
  } else {
    $(".wrong-network-modal").removeClass("hidden");
    return;
  }

  var price = parseFloat($(".select-trending-time.active").data("tokens-count")) * (10**9);
  if(price == undefined || price == null || price <= 0) {
    $("#txn-status").html('<div class="alert alert-warning">No period selected for the double voting!</div>');
    $(this_btn).removeClass("disabled");
    return;
  }
  var token_address = $("#search-space-trending-spot-results .selected").data("address");
  if(token_address == undefined || token_address == null || token_address.length !== 42) {
    $("#txn-status").html('<div class="alert alert-warning">No space selected for the double voting!</div>');
    $(this_btn).removeClass("disabled");
    return;
  }

  var sender_balance;
  var token_abi;
  await fetch("/abi/standard-abi.json").then(response => response.json()).then(function(json){
    token_abi = json;
  });
  var token_contract = await new web3.eth.Contract(token_abi, spaces_contract_address);
  await token_contract.methods.balanceOf(sender).call().then((balance) => {
    sender_balance = balance;
	});
  if(sender_balance < price) {
    $("#txn-status").html('<div class="alert alert-warning">Your balance of SPACES are too low for this buy!</div>');
    $(this_btn).removeClass("disabled");
    return;
  }

  var contract_abi;
  await fetch("/abi/platform-purchases-abi.json").then(response => response.json()).then(function(json){
    contract_abi = json;
  });

  $(this_btn).html('<div class="spinner-border"></div>');
  var contract = await new web3.eth.Contract(contract_abi, spaces_purchase_contract);
  await contract.methods.buy(
    web3.utils.toBN(BigNumber(price)),
    token_address,
    $(this_btn).data("user"),
    "double-voting"
  ).send({from: sender})
  .on('transactionHash', function(res, err){
    $(this_btn).html('<div class="spinner-border color-info"></div>');
  }).on('confirmation', () => {}).then((receipt) => {
    $("#txn-status").html('<div class="alert alert-success">Your purchase is confirmed and pending block confirmation!<br><small>You may freely leave this page.</small></div>');
    $(this_btn).closest(".card-footer").addClass("d-none");
    return;
  }).catch(function(ei){
    console.log(ei);
    $(this_btn).removeClass("disabled").html(this_btn_content);
    $("#txn-status").html('<div class="alert alert-warning">An unknown error occured. Please try again!</div>');
    return;
  });
}


$(document).on("click", "#pay-trending-booking-btn", function(){
  var this_btn = $(this);
  var this_btn_content = $(this_btn).html();
  if(!$(this_btn).hasClass("disabled")) {
    buyTrendingPromotion($(this_btn));
  }
});

async function buyTrendingPromotion(this_btn){
  var this_btn_content = $(this_btn).html();
  $("#txn-status").html('');
  $(this_btn).addClass("disabled");

  provider = await web3Modal.connect();
  web3 = new Web3(provider);
  var accounts = await web3.eth.getAccounts();
  var sender = accounts[0];
  var account_balance = await web3.eth.getBalance(sender);
  var chainId = await web3.eth.getChainId();

  if(chainId == "1") {
    var spaces_contract_address = "0x29cED58cd96f523f86f2771d79D64A8f58F55f5E";
    var spaces_purchase_contract = "0xc32a28193D25d45040233C05C9C8db49b4c46A79";
  } else if(chainId == "56") {
    var spaces_contract_address = "0x156df0dd6300C73ac692D805720967cf4464776e";
    var spaces_purchase_contract = "0x069B7e05e3aB68dc7410b93A314662D22049B1e1";
  } else if(chainId == "18159") {
    var spaces_contract_address = "0x90242D0A1BC0aaCE16585848e3a032949539bbcc";
    var spaces_purchase_contract = "";
  } else if (chainId == "42161") {
    var spaces_contract_address = "0x1D05Ec50dfE0A44a396B5c68B7c482E90563252D";
    var spaces_purchase_contract = "0x93761Ff413fd905a73c5d3b9A8f6BC97df6E01A9";
  } else {
    $(".wrong-network-modal").removeClass("hidden");
    return;
  }

  var trending_price = parseFloat($(".select-trending-time.active").data("tokens-count")) * (10**9);
  if(trending_price == undefined || trending_price == null || trending_price <= 0) {
    $("#txn-status").html('<div class="alert alert-warning">No period selected for the trending booking!</div>');
    $(this_btn).removeClass("disabled");
    return;
  }
  var token_address = $("#search-space-trending-spot-results .selected").data("address");
  if(token_address == undefined || token_address == null || token_address.length !== 42) {
    $("#txn-status").html('<div class="alert alert-warning">No space selected for the trending booking!</div>');
    $(this_btn).removeClass("disabled");
    return;
  }

  var sender_balance;
  var token_abi;
  await fetch("/abi/standard-abi.json").then(response => response.json()).then(function(json){
    token_abi = json;
  });
  var token_contract = await new web3.eth.Contract(token_abi, spaces_contract_address);
  await token_contract.methods.balanceOf(sender).call().then((balance) => {
    sender_balance = balance;
	});
  if(sender_balance < trending_price) {
    $("#txn-status").html('<div class="alert alert-warning">Your balance of SPACES are too low for this buy!</div>');
    $(this_btn).removeClass("disabled");
    return;
  }

  var contract_abi;
  await fetch("/abi/platform-purchases-abi.json").then(response => response.json()).then(function(json){
    contract_abi = json;
  });

  $(this_btn).html('<div class="spinner-border"></div>');
  var contract = await new web3.eth.Contract(contract_abi, spaces_purchase_contract);
  await contract.methods.buy(
    web3.utils.toBN(BigNumber(trending_price)),
    token_address,
    $(this_btn).data("user"),
    "trending-booking"
  ).send({from: sender})
  .on('transactionHash', function(res, err){
    $(this_btn).html('<div class="spinner-border color-info"></div>');
  }).on('confirmation', () => {}).then((receipt) => {
    $("#txn-status").html('<div class="alert alert-success">Your purchase is confirmed and pending block confirmation!<br><small>You may freely leave this page.</small></div>');
    $(this_btn).closest(".card-footer").addClass("d-none");
    return;
  }).catch(function(ei){
    console.log(ei);
    $(this_btn).removeClass("disabled").html(this_btn_content);
    $("#txn-status").html('<div class="alert alert-warning">An unknown error occured. Please try again!</div>');
    return;
  });
}

async function checkForApproval(type) {
  var approve_btn = $("#approve-platform-purchase-contract-btn");

  provider = await web3Modal.connect();
  web3 = new Web3(provider);
  var accounts = await web3.eth.getAccounts();
  var sender = accounts[0];
  var account_balance = await web3.eth.getBalance(sender);
  var chainId = await web3.eth.getChainId();

  if(chainId == "1") {
    var spaces_contract_address = "0x29cED58cd96f523f86f2771d79D64A8f58F55f5E";
    var spaces_purchase_contract = "0xc32a28193D25d45040233C05C9C8db49b4c46A79";
  } else if(chainId == "56") {
    var spaces_contract_address = "0x156df0dd6300C73ac692D805720967cf4464776e";
    var spaces_purchase_contract = "0x069B7e05e3aB68dc7410b93A314662D22049B1e1";
  } else if(chainId == "18159") {
    var spaces_contract_address = "0x90242D0A1BC0aaCE16585848e3a032949539bbcc";
    var spaces_purchase_contract = "";
  } else if (chainId == "42161") {
    var spaces_contract_address = "0x1D05Ec50dfE0A44a396B5c68B7c482E90563252D";
    var spaces_purchase_contract = "0x93761Ff413fd905a73c5d3b9A8f6BC97df6E01A9";
  } else {
    $(".wrong-network-modal").removeClass("hidden");
    return;
  }

  if(spaces_purchase_contract.length == 0) {
    $("#txn-status").html('<div class="alert alert-warning">You\'re currently connected to a chain not yet implemented for purchases! As the AstroSpaces platform grows we\'ll connect more blockchains in the future!</div>');
  }
  var contract_abi;
  await fetch("/abi/standard-abi.json").then(response => response.json()).then(function(json){
    contract_abi = json;
  });

  var contract = await new web3.eth.Contract(contract_abi, spaces_contract_address);
  await contract.methods.allowance(sender, spaces_purchase_contract).call().then((allowance) => {
    if(allowance < 140000000 * (10**9)) {
      $(approve_btn).removeClass("disabled");
    } else {
      $(approve_btn).addClass("disabled").html('Approved');
      if(type == "trending-booking") {
        $("#pay-trending-booking-btn").removeClass("disabled");
      } else if(type == "double-voting") {
        $("#pay-double-voting-btn").removeClass("disabled");
      }
    }
	});
}

$(document).on("click", "#approve-platform-purchase-contract-btn", function(){
  var this_btn = $(this);
  if(!$(this_btn).hasClass("disabled")) {
    approvalSpacesPurchaseContract($(this_btn));
  }
});
async function approvalSpacesPurchaseContract(this_btn) {
  var this_btn_content = $(this_btn).html();

  provider = await web3Modal.connect();
  web3 = new Web3(provider);
  var accounts = await web3.eth.getAccounts();
  var sender = accounts[0];
  var account_balance = await web3.eth.getBalance(sender);
  var chainId = await web3.eth.getChainId();

  if(chainId == "1") {
    var spaces_contract_address = "0x29cED58cd96f523f86f2771d79D64A8f58F55f5E";
    var spaces_purchase_contract = "0xc32a28193D25d45040233C05C9C8db49b4c46A79";
  } else if(chainId == "56") {
    var spaces_contract_address = "0x156df0dd6300C73ac692D805720967cf4464776e";
    var spaces_purchase_contract = "0x069B7e05e3aB68dc7410b93A314662D22049B1e1";
  } else if(chainId == "18159") {
    var spaces_contract_address = "0x90242D0A1BC0aaCE16585848e3a032949539bbcc";
    var spaces_purchase_contract = "";
  } else if (chainId == "42161") {
    var spaces_contract_address = "0x1D05Ec50dfE0A44a396B5c68B7c482E90563252D";
    var spaces_purchase_contract = "0x93761Ff413fd905a73c5d3b9A8f6BC97df6E01A9";
  } else {
    $(".wrong-network-modal").removeClass("hidden");
    return;
  }

  $(this_btn).addClass("disabled");

  var contract_abi;
  await fetch("/abi/standard-abi.json").then(response => response.json()).then(function(json){
    contract_abi = json;
  });

  $(this_btn).html('<div class="spinner-border"></div>');
  var contract = await new web3.eth.Contract(contract_abi, spaces_contract_address);
  await contract.methods.approve(spaces_purchase_contract, "115792089237316195423570985008687907853269984665640564039457584007913129639935").send({from: sender})
  .on('transactionHash', function(res, err){
		$(this_btn).html('<div class="spinner-border color-info"></div>');
	}).on('confirmation', () => {}).then((receipt) => {
    if($("#payment-gateway-trending-booking")[0]) {
      checkForApproval("trending-booking");
    }
	}).catch(function(ei){
    $(this_btn).removeClass("disabled").html(this_btn_content);
	});
}
